import debug from 'debug';
import deepmerge from 'deepmerge';
import axios from 'axios';
import Vue from 'vue';

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var log = debug('xpedeo-core:history');
debug.enable(process.env.VUE_APP_DEBUG);
var History = {
  __homePages: [],
  __nextPageId: null,
  __historyArray: [],
  __router: null,
  __$xp: null,

  // @deprecated
  get homePageId() {
    if (this.__homePages.length) {
      return this.__homePages[this.__homePages.length - 1].id;
    }

    return null;
  },

  // @deprecated
  get previousHomePageId() {
    if (this.__homePages.length > 1) {
      return this.__homePages[this.__homePages.length - 2].id;
    }

    return null;
  },

  // @deprecated
  get homePage() {
    if (this.__homePages.length) {
      return this.__homePages[this.__homePages.length - 1];
    }

    return null;
  },

  // @deprecated
  get previousHomePage() {
    if (this.__homePages.length > 1) {
      return this.__homePages[this.__homePages.length - 2];
    }

    return null;
  },

  get lastHomePage() {
    if (this.__homePages[this.__homePages.length - 1]) {
      if (this.__homePages[this.__homePages.length - 1].id === this.__$xp.content.pageData.ID || // if we are in the last saved home page
      this.__$xp.content.pageData.Homepage && this.__homePages[this.__homePages.length - 1].id === this.__$xp.content.pageData.Homepage.ID // in case we are in a page that already renders the last saved home page tabs
      ) {
          return this.__homePages[this.__homePages.length - 2];
        } else {
        return this.__homePages[this.__homePages.length - 1];
      }
    }
  },

  get nextPageId() {
    return this.__nextPageId || null;
  },

  get historyArray() {
    return this.__historyArray;
  },

  get historyParams() {
    return this.__historyArray.length > 0 ? this.__historyArray[this.__historyArray.length - 1].params : {};
  },

  set nextPageId(id) {
    this.__nextPageId = id;
  },

  resetHistoryState: function resetHistoryState() {
    this.__homePages = [];
    this.__nextPageId = null;
    this.__historyArray = [];
  },
  addHomePage: function addHomePage(pageId, pagePath, pageTitle) {
    log("addHomePage(".concat(pageId, ", ").concat(pagePath, ", ").concat(pageTitle, ")"));
    pageId = parseInt(pageId);

    var searchIndex = this.__homePages.findIndex(function (item) {
      return item.id === pageId;
    });

    if (searchIndex > -1) {
      this.__homePages = this.__homePages.slice(0, searchIndex);
    }

    this.__homePages.push({
      id: pageId,
      path: pagePath,
      title: pageTitle
    });

    log({
      __homePages: this.__homePages
    });
  },
  push: function push(newPageId, newPath) {
    var searchIndex = this.__historyArray.findIndex(function (item) {
      return item.pageId === parseInt(newPageId);
    });

    if (searchIndex > -1) {
      if (searchIndex < this.__historyArray.length) {
        this.__historyArray = this.__historyArray.slice(0, searchIndex + 1);
      }
    } else {
      this.__historyArray.push({
        pageId: parseInt(newPageId),
        path: newPath,
        params: {}
      });
    }
  },
  replace: function replace(newPageId, newPath) {
    this.__historyArray.splice(-1, 1);

    this.__historyArray.push({
      pageId: parseInt(newPageId),
      path: newPath,
      params: {}
    });
  },
  setHistoryParam: function setHistoryParam(pageId, key, value) {
    pageId = parseInt(pageId);

    if (this.__historyArray.length > 0) {
      if (this.__historyArray[this.__historyArray.length - 1].pageId === pageId) {
        this.__historyArray[this.__historyArray.length - 1].params = Object.assign({}, this.__historyArray[this.__historyArray.length - 1].params, _defineProperty({}, key, value));
      } else {
        console.warn("setHistoryParam: ".concat(key, " = ").concat(value, ". pageId does not match the last element in the history array \n ").concat(pageId, " was passed and ").concat(this.__historyArray[this.__historyArray.length - 1].pageId, " was found"));
      }
    }
  },
  back: function back(replace) {
    if (this.__historyArray.length > 1) {
      var lastPagePath = this.__historyArray[this.__historyArray.length - 2].path; // commit('BACK')

      this.__historyArray.splice(-1, 1);

      this.__router.push({
        path: lastPagePath,
        query: {
          back: true
        },
        replace: replace
      });
    }
  },
  goHome: function goHome(replace) {
    if (this.lastHomePage) {
      log('GO HOME: (previous)' + this.lastHomePage.path);

      this.__router.push({
        path: this.lastHomePage.path,
        replace: replace
      });
    } else {
      log('GO START');

      this.__router.push({
        path: '/',
        replace: replace
      });
    }
  },
  saveHistoryState: function saveHistoryState() {
    console.log('Saving history state');
    window.localStorage.setItem('HomePages', JSON.stringify(this.__homePages));
    window.localStorage.setItem('nextPageId', this.__nextPageId);
    window.localStorage.setItem('historyArray', JSON.stringify(this.__historyArray));
  },
  restoreHistoryState: function restoreHistoryState() {
    console.log('Restoring history state');
    this.__homePages = JSON.parse(window.localStorage.getItem('HomePages'));
    window.localStorage.setItem('HomePages', '');
    var storedNextPageId = window.localStorage.getItem('nextPageId');
    this.__nextPageId = storedNextPageId ? Number(storedNextPageId) : null;
    window.localStorage.setItem('nextPageId', '');
    this.__historyArray = JSON.parse(window.localStorage.getItem('historyArray'));
    window.localStorage.setItem('historyArray', '');
  },
  install: function install(Vue, opts, $xp, cfg) {
    if ($xp.historyInstalled) {
      return;
    }

    this.__$xp = $xp;

    if (!opts.router) {
      throw new Error('History plugin needs router to initialize');
    }

    this.__router = opts.router;
    $xp.historyInstalled = true;
    Vue.util.defineReactive($xp, 'history', this);
  }
};

var Polyglot = {
  __locale: 'de_DE',
  __urlPath: '_/',
  __defaultLocale: null,
  __i18n: null,

  get locale() {
    return this.__locale;
  },

  get urlPath() {
    return this.__urlPath;
  },

  get rtl() {
    return this.__locale.startsWith('ar_') || this.__locale.startsWith('fa_') || this.__locale.startsWith('he_');
  },

  get apiLangPath() {
    return this.__urlPath === '_/' ? '' : this.__urlPath;
  },

  set locale(locale) {
    this.__locale = locale;
  },

  set urlPath(urlPath) {
    this.__urlPath = urlPath || '_/';
  },

  setLanguage: function setLanguage(locale, urlPath) {
    this.__locale = locale;
    this.__urlPath = urlPath || '_/';
    this.setI18nLanguage(locale);
  },
  setI18nLanguage: function setI18nLanguage(lang) {
    lang = lang || this.__defaultLocale;
    this.__i18n.locale = lang;
    var langParts = lang.split('_');

    if (langParts.length !== 2) {
      throw new Error("setI18nLanguage: invalid locale ".concat(lang));
    }

    document.querySelector('html').setAttribute('lang', langParts[1].toLowerCase());
  },
  install: function install(Vue, opts, $xp, cfg) {
    if ($xp.polyglotInstalled) {
      return;
    }

    this.__defaultLocale = cfg.defaultLocale;
    this.__i18n = cfg.i18n;
    $xp.polyglotInstalled = true;
    this.setI18nLanguage();
    Vue.util.defineReactive($xp, 'polyglot', this); // $xp.polyglot = this
  }
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var runtime = function (exports) {

    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined$1; // More compressible than void 0.

    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.

      generator._invoke = makeInvokeMethod(innerFn, self, context);
      return generator;
    }

    exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.

    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }

    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.

    var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.

    function Generator() {}

    function GeneratorFunction() {}

    function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.


    var IteratorPrototype = {};

    IteratorPrototype[iteratorSymbol] = function () {
      return this;
    };

    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }

    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction"; // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.

    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        prototype[method] = function (arg) {
          return this._invoke(method, arg);
        };
      });
    }

    exports.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };

    exports.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;

        if (!(toStringTagSymbol in genFun)) {
          genFun[toStringTagSymbol] = "GeneratorFunction";
        }
      }

      genFun.prototype = Object.create(Gp);
      return genFun;
    }; // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.


    exports.awrap = function (arg) {
      return {
        __await: arg
      };
    };

    function AsyncIterator(generator) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);

        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;

          if (value && _typeof(value) === "object" && hasOwn.call(value, "__await")) {
            return Promise.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }

          return Promise.resolve(value).then(function (unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration.
            result.value = unwrapped;
            resolve(result);
          }, function (error) {
            // If a rejected Promise was yielded, throw the rejection back
            // into the async generator function so it can be handled there.
            return invoke("throw", error, resolve, reject);
          });
        }
      }

      var previousPromise;

      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new Promise(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }

        return previousPromise = // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
        // invocations of the iterator.
        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      } // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).


      this._invoke = enqueue;
    }

    defineIteratorMethods(AsyncIterator.prototype);

    AsyncIterator.prototype[asyncIteratorSymbol] = function () {
      return this;
    };

    exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.

    exports.async = function (innerFn, outerFn, self, tryLocsList) {
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
      return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };

    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }

        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          } // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


          return doneResult();
        }

        context.method = method;
        context.arg = arg;

        while (true) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }

            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }

          state = GenStateExecuting;
          var record = tryCatch(innerFn, self, context);

          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;

            if (record.arg === ContinueSentinel) {
              continue;
            }

            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted; // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.

            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    } // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.


    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];

      if (method === undefined$1) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;

        if (context.method === "throw") {
          // Note: ["return"] must be used for ES3 parsing compatibility.
          if (delegate.iterator["return"]) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined$1;
            maybeInvokeDelegate(delegate, context);

            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }

          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return ContinueSentinel;
      }

      var record = tryCatch(method, delegate.iterator, context.arg);

      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }

      var info = record.arg;

      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }

      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

        context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.

        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined$1;
        }
      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      } // The delegate iterator is finished, so forget it and continue with
      // the outer generator.


      context.delegate = null;
      return ContinueSentinel;
    } // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.


    defineIteratorMethods(Gp);
    Gp[toStringTagSymbol] = "Generator"; // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.

    Gp[iteratorSymbol] = function () {
      return this;
    };

    Gp.toString = function () {
      return "[object Generator]";
    };

    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };

      if (1 in locs) {
        entry.catchLoc = locs[1];
      }

      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }

      this.tryEntries.push(entry);
    }

    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }

    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }

    exports.keys = function (object) {
      var keys = [];

      for (var key in object) {
        keys.push(key);
      }

      keys.reverse(); // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.

      return function next() {
        while (keys.length) {
          var key = keys.pop();

          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        } // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.


        next.done = true;
        return next;
      };
    };

    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];

        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }

        if (typeof iterable.next === "function") {
          return iterable;
        }

        if (!isNaN(iterable.length)) {
          var i = -1,
              next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }

            next.value = undefined$1;
            next.done = true;
            return next;
          };

          return next.next = next;
        }
      } // Return an iterator with no values.


      return {
        next: doneResult
      };
    }

    exports.values = values;

    function doneResult() {
      return {
        value: undefined$1,
        done: true
      };
    }

    Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        this.prev = 0;
        this.next = 0; // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.

        this.sent = this._sent = undefined$1;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined$1;
        this.tryEntries.forEach(resetTryEntry);

        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined$1;
            }
          }
        }
      },
      stop: function stop() {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;

        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }

        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) {
          throw exception;
        }

        var context = this;

        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;

          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined$1;
          }

          return !!caught;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;

          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }

          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");

            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }

        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }

        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;

        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }

        return this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }

        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }

        return ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;

            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }

            return thrown;
          }
        } // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.


        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };

        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined$1;
        }

        return ContinueSentinel;
      }
    }; // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.

    return exports;
  }( // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports );

  try {
    regeneratorRuntime = runtime;
  } catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    Function("r", "regeneratorRuntime = r")(runtime);
  }
});

var regenerator = runtime_1;

var goToAdminActivity = function goToAdminActivity() {
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_IS_LOAN_DEVICE) {
      window.XpedeoPreloader.goToAdminActivity(function () {
        resolve();
      }, function (errMsg) {
        reject(new Error(errMsg));
      });
    }
  });
};

var getDeviceTimeOffset = function getDeviceTimeOffset() {
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_IS_LOAN_DEVICE) {
      window.XpedeoPreloader.getDeviceTimeOffset(function (offset) {
        resolve(offset);
      }, function (errMsg) {
        reject(new Error(errMsg));
      });
    }
  });
};

var getRemappedUrl = function getRemappedUrl(url) {
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_IS_LOAN_DEVICE) {
      // if (window.device.platform !== 'browser' && window.device.platform !== 'ios') {
      window.XpedeoPreloader.getRemappedUrl(url, function (remappedUrl) {
        resolve(remappedUrl);
      }, function (errMsg) {
        reject(new Error(errMsg));
      });
    } else {
      resolve(url);
    }
  });
};

var checkPermissions = function checkPermissions() {
  var permissions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_PLATFORM.toLowerCase() === 'android') {
      var diagnostic = window.cordova.plugins.diagnostic;

      if (process.env.VUE_APP_IS_LOAN_DEVICE) {
        permissions = [diagnostic.permission.WRITE_EXTERNAL_STORAGE, diagnostic.permission.READ_EXTERNAL_STORAGE, diagnostic.permission.ACCESS_FINE_LOCATION, diagnostic.permission.ACCESS_COARSE_LOCATION];
      } else {
        permissions = permissions.map(function (item) {
          return diagnostic.permission[item];
        });
      }

      permissions.length === 0 && resolve();
      permissions.length && diagnostic.requestRuntimePermissions(function (statuses) {
        var grantedCounter = 0;

        for (var permission in statuses) {
          switch (statuses[permission]) {
            case diagnostic.permissionStatus.GRANTED:
              console.log('Permission granted to use ' + permission);
              grantedCounter += 1;
              break;

            case diagnostic.permissionStatus.NOT_REQUESTED:
              console.log('Permission to use ' + permission + ' has not been requested yet');
              break;

            case diagnostic.permissionStatus.DENIED:
              console.log('Permission denied to use ' + permission + ' - ask again?');
              break;

            case diagnostic.permissionStatus.DENIED_ALWAYS:
              console.log('Permission permanently denied to use ' + permission + ' - guess we won\'t be using it then!');
              break;
          }
        }

        if (grantedCounter === Object.keys(statuses).length) {
          resolve();
        } else {
          reject(new Error("Permissions were not granted. ".concat(Object.keys(statuses).length, " were requested but ").concat(grantedCounter, " were granted.")));
        }
      }, function (error) {
        reject(new Error(error));
      }, permissions);
    } else {
      resolve();
    }
  });
};

var checkLocationSettings = function checkLocationSettings() {
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_IS_LOAN_DEVICE) {
      window.XpedeoPreloader.checkLocationSettings(function () {
        resolve();
      }, function () {
        reject(new Error('location settings are not valid'));
      });
    } else {
      resolve();
    }
  });
};

var writeEvaRecord = function writeEvaRecord(jsonString) {
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_PLATFORM.toLowerCase() === 'android') {
      window.XpedeoPreloader.writeEvaRecord(jsonString ? [jsonString] : [], function () {
        console.log('mediaRecord Written');
        resolve();
      }, function () {
        reject(new Error('Evaluation record not written'));
      });
    } else {
      resolve();
    }
  });
};

var fingerprint = createCommonjsModule(function (module) {
  /* based on https://github.com/Valve/fingerprintjs2 */

  /*
  * This software contains code from open-source projects:
  * MurmurHash3 by Karan Lyons (https://github.com/karanlyons/murmurHash3.js)
  */

  /* global define */
  (function (name, context, definition) {

    if (typeof window !== 'undefined' && typeof undefined === 'function' && undefined.amd) {
      undefined(definition);
    } else if ( module.exports) {
      module.exports = definition();
    } else if (context.exports) {
      context.exports = definition();
    } else {
      context[name] = definition();
    }
  })('Fingerprint2', commonjsGlobal, function () {
    // only implement if no native implementation is available

    if (typeof Array.isArray === 'undefined') {
      Array.isArray = function (obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
      };
    }
    //
    // Given two 64bit ints (as an array of two 32bit ints) returns the two
    // added together as a 64bit int (as an array of two 32bit ints).
    //

    var x64Add = function x64Add(m, n) {
      m = [m[0] >>> 16, m[0] & 0xffff, m[1] >>> 16, m[1] & 0xffff];
      n = [n[0] >>> 16, n[0] & 0xffff, n[1] >>> 16, n[1] & 0xffff];
      var o = [0, 0, 0, 0];
      o[3] += m[3] + n[3];
      o[2] += o[3] >>> 16;
      o[3] &= 0xffff;
      o[2] += m[2] + n[2];
      o[1] += o[2] >>> 16;
      o[2] &= 0xffff;
      o[1] += m[1] + n[1];
      o[0] += o[1] >>> 16;
      o[1] &= 0xffff;
      o[0] += m[0] + n[0];
      o[0] &= 0xffff;
      return [o[0] << 16 | o[1], o[2] << 16 | o[3]];
    }; //
    // Given two 64bit ints (as an array of two 32bit ints) returns the two
    // multiplied together as a 64bit int (as an array of two 32bit ints).
    //


    var x64Multiply = function x64Multiply(m, n) {
      m = [m[0] >>> 16, m[0] & 0xffff, m[1] >>> 16, m[1] & 0xffff];
      n = [n[0] >>> 16, n[0] & 0xffff, n[1] >>> 16, n[1] & 0xffff];
      var o = [0, 0, 0, 0];
      o[3] += m[3] * n[3];
      o[2] += o[3] >>> 16;
      o[3] &= 0xffff;
      o[2] += m[2] * n[3];
      o[1] += o[2] >>> 16;
      o[2] &= 0xffff;
      o[2] += m[3] * n[2];
      o[1] += o[2] >>> 16;
      o[2] &= 0xffff;
      o[1] += m[1] * n[3];
      o[0] += o[1] >>> 16;
      o[1] &= 0xffff;
      o[1] += m[2] * n[2];
      o[0] += o[1] >>> 16;
      o[1] &= 0xffff;
      o[1] += m[3] * n[1];
      o[0] += o[1] >>> 16;
      o[1] &= 0xffff;
      o[0] += m[0] * n[3] + m[1] * n[2] + m[2] * n[1] + m[3] * n[0];
      o[0] &= 0xffff;
      return [o[0] << 16 | o[1], o[2] << 16 | o[3]];
    }; //
    // Given a 64bit int (as an array of two 32bit ints) and an int
    // representing a number of bit positions, returns the 64bit int (as an
    // array of two 32bit ints) rotated left by that number of positions.
    //


    var x64Rotl = function x64Rotl(m, n) {
      n %= 64;

      if (n === 32) {
        return [m[1], m[0]];
      } else if (n < 32) {
        return [m[0] << n | m[1] >>> 32 - n, m[1] << n | m[0] >>> 32 - n];
      } else {
        n -= 32;
        return [m[1] << n | m[0] >>> 32 - n, m[0] << n | m[1] >>> 32 - n];
      }
    }; //
    // Given a 64bit int (as an array of two 32bit ints) and an int
    // representing a number of bit positions, returns the 64bit int (as an
    // array of two 32bit ints) shifted left by that number of positions.
    //


    var x64LeftShift = function x64LeftShift(m, n) {
      n %= 64;

      if (n === 0) {
        return m;
      } else if (n < 32) {
        return [m[0] << n | m[1] >>> 32 - n, m[1] << n];
      } else {
        return [m[1] << n - 32, 0];
      }
    }; //
    // Given two 64bit ints (as an array of two 32bit ints) returns the two
    // xored together as a 64bit int (as an array of two 32bit ints).
    //


    var x64Xor = function x64Xor(m, n) {
      return [m[0] ^ n[0], m[1] ^ n[1]];
    }; //
    // Given a block, returns murmurHash3's final x64 mix of that block.
    // (`[0, h[0] >>> 1]` is a 33 bit unsigned right shift. This is the
    // only place where we need to right shift 64bit ints.)
    //


    var x64Fmix = function x64Fmix(h) {
      h = x64Xor(h, [0, h[0] >>> 1]);
      h = x64Multiply(h, [0xff51afd7, 0xed558ccd]);
      h = x64Xor(h, [0, h[0] >>> 1]);
      h = x64Multiply(h, [0xc4ceb9fe, 0x1a85ec53]);
      h = x64Xor(h, [0, h[0] >>> 1]);
      return h;
    }; //
    // Given a string and an optional seed as an int, returns a 128 bit
    // hash using the x64 flavor of MurmurHash3, as an unsigned hex.
    //


    var x64hash128 = function x64hash128(key, seed) {
      key = key || '';
      seed = seed || 0;
      var remainder = key.length % 16;
      var bytes = key.length - remainder;
      var h1 = [0, seed];
      var h2 = [0, seed];
      var k1 = [0, 0];
      var k2 = [0, 0];
      var c1 = [0x87c37b91, 0x114253d5];
      var c2 = [0x4cf5ad43, 0x2745937f];

      for (var i = 0; i < bytes; i = i + 16) {
        k1 = [key.charCodeAt(i + 4) & 0xff | (key.charCodeAt(i + 5) & 0xff) << 8 | (key.charCodeAt(i + 6) & 0xff) << 16 | (key.charCodeAt(i + 7) & 0xff) << 24, key.charCodeAt(i) & 0xff | (key.charCodeAt(i + 1) & 0xff) << 8 | (key.charCodeAt(i + 2) & 0xff) << 16 | (key.charCodeAt(i + 3) & 0xff) << 24];
        k2 = [key.charCodeAt(i + 12) & 0xff | (key.charCodeAt(i + 13) & 0xff) << 8 | (key.charCodeAt(i + 14) & 0xff) << 16 | (key.charCodeAt(i + 15) & 0xff) << 24, key.charCodeAt(i + 8) & 0xff | (key.charCodeAt(i + 9) & 0xff) << 8 | (key.charCodeAt(i + 10) & 0xff) << 16 | (key.charCodeAt(i + 11) & 0xff) << 24];
        k1 = x64Multiply(k1, c1);
        k1 = x64Rotl(k1, 31);
        k1 = x64Multiply(k1, c2);
        h1 = x64Xor(h1, k1);
        h1 = x64Rotl(h1, 27);
        h1 = x64Add(h1, h2);
        h1 = x64Add(x64Multiply(h1, [0, 5]), [0, 0x52dce729]);
        k2 = x64Multiply(k2, c2);
        k2 = x64Rotl(k2, 33);
        k2 = x64Multiply(k2, c1);
        h2 = x64Xor(h2, k2);
        h2 = x64Rotl(h2, 31);
        h2 = x64Add(h2, h1);
        h2 = x64Add(x64Multiply(h2, [0, 5]), [0, 0x38495ab5]);
      }

      k1 = [0, 0];
      k2 = [0, 0];

      switch (remainder) {
        case 15:
          k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 14)], 48));
        // fallthrough

        case 14:
          k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 13)], 40));
        // fallthrough

        case 13:
          k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 12)], 32));
        // fallthrough

        case 12:
          k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 11)], 24));
        // fallthrough

        case 11:
          k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 10)], 16));
        // fallthrough

        case 10:
          k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 9)], 8));
        // fallthrough

        case 9:
          k2 = x64Xor(k2, [0, key.charCodeAt(i + 8)]);
          k2 = x64Multiply(k2, c2);
          k2 = x64Rotl(k2, 33);
          k2 = x64Multiply(k2, c1);
          h2 = x64Xor(h2, k2);
        // fallthrough

        case 8:
          k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 7)], 56));
        // fallthrough

        case 7:
          k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 6)], 48));
        // fallthrough

        case 6:
          k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 5)], 40));
        // fallthrough

        case 5:
          k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 4)], 32));
        // fallthrough

        case 4:
          k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 3)], 24));
        // fallthrough

        case 3:
          k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 2)], 16));
        // fallthrough

        case 2:
          k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 1)], 8));
        // fallthrough

        case 1:
          k1 = x64Xor(k1, [0, key.charCodeAt(i)]);
          k1 = x64Multiply(k1, c1);
          k1 = x64Rotl(k1, 31);
          k1 = x64Multiply(k1, c2);
          h1 = x64Xor(h1, k1);
        // fallthrough
      }

      h1 = x64Xor(h1, [0, key.length]);
      h2 = x64Xor(h2, [0, key.length]);
      h1 = x64Add(h1, h2);
      h2 = x64Add(h2, h1);
      h1 = x64Fmix(h1);
      h2 = x64Fmix(h2);
      h1 = x64Add(h1, h2);
      h2 = x64Add(h2, h1);
      return ('00000000' + (h1[0] >>> 0).toString(16)).slice(-8) + ('00000000' + (h1[1] >>> 0).toString(16)).slice(-8) + ('00000000' + (h2[0] >>> 0).toString(16)).slice(-8) + ('00000000' + (h2[1] >>> 0).toString(16)).slice(-8);
    };

    var defaultOptions = {
      preprocessor: null,
      audio: {
        timeout: 1000,
        // On iOS 11, audio context can only be used in response to user interaction.
        // We require users to explicitly enable audio fingerprinting on iOS 11.
        // See https://stackoverflow.com/questions/46363048/onaudioprocess-not-called-on-ios11#46534088
        excludeIOS11: true
      },
      fonts: {
        swfContainerId: 'fingerprintjs2',
        swfPath: 'flash/compiled/FontList.swf',
        userDefinedFonts: [],
        extendedJsFonts: false
      },
      screen: {
        // To ensure consistent fingerprints when users rotate their mobile devices
        detectScreenOrientation: true
      },
      plugins: {
        sortPluginsFor: [/palemoon/i],
        excludeIE: false
      },
      extraComponents: [],
      excludes: {
        // Unreliable on Windows, see https://github.com/Valve/fingerprintjs2/issues/375
        'enumerateDevices': true,
        // devicePixelRatio depends on browser zoom, and it's impossible to detect browser zoom
        'pixelRatio': true,
        // DNT depends on incognito mode for some browsers (Chrome) and it's impossible to detect incognito mode
        'doNotTrack': true,
        // uses js fonts already
        'fontsFlash': true
      },
      NOT_AVAILABLE: 'not available',
      ERROR: 'error',
      EXCLUDED: 'excluded'
    };

    var each = function each(obj, iterator) {
      if (Array.prototype.forEach && obj.forEach === Array.prototype.forEach) {
        obj.forEach(iterator);
      } else if (obj.length === +obj.length) {
        for (var i = 0, l = obj.length; i < l; i++) {
          iterator(obj[i], i, obj);
        }
      } else {
        for (var key in obj) {
          if (obj.hasOwnProperty(key)) {
            iterator(obj[key], key, obj);
          }
        }
      }
    };

    var map = function map(obj, iterator) {
      var results = []; // Not using strict equality so that this acts as a
      // shortcut to checking for `null` and `undefined`.

      if (obj == null) {
        return results;
      }

      if (Array.prototype.map && obj.map === Array.prototype.map) {
        return obj.map(iterator);
      }

      each(obj, function (value, index, list) {
        results.push(iterator(value, index, list));
      });
      return results;
    };

    var extendSoft = function extendSoft(target, source) {
      if (source == null) {
        return target;
      }

      var value;
      var key;

      for (key in source) {
        value = source[key];

        if (value != null && !Object.prototype.hasOwnProperty.call(target, key)) {
          target[key] = value;
        }
      }

      return target;
    };

    var getCanvasFp = function getCanvasFp(options) {
      var result = []; // Very simple now, need to make it more complex (geo shapes etc)

      var canvas = document.createElement('canvas');
      canvas.width = 2000;
      canvas.height = 200;
      canvas.style.display = 'inline';
      var ctx = canvas.getContext('2d'); // detect browser support of canvas winding
      // http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
      // https://github.com/Modernizr/Modernizr/blob/master/feature-detects/canvas/winding.js

      ctx.rect(0, 0, 10, 10);
      ctx.rect(2, 2, 6, 6);
      result.push('canvas winding:' + (ctx.isPointInPath(5, 5, 'evenodd') === false ? 'yes' : 'no'));
      ctx.textBaseline = 'alphabetic';
      ctx.fillStyle = '#f60';
      ctx.fillRect(125, 1, 62, 20);
      ctx.fillStyle = '#069'; // https://github.com/Valve/fingerprintjs2/issues/66

      if (options.dontUseFakeFontInCanvas) {
        ctx.font = '11pt Arial';
      } else {
        ctx.font = '11pt no-real-font-123';
      }

      ctx.fillText("Cwm fjordbank glyphs vext quiz, \uD83D\uDE03", 2, 15);
      ctx.fillStyle = 'rgba(102, 204, 0, 0.2)';
      ctx.font = '18pt Arial';
      ctx.fillText("Cwm fjordbank glyphs vext quiz, \uD83D\uDE03", 4, 45); // canvas blending
      // http://blogs.adobe.com/webplatform/2013/01/28/blending-features-in-canvas/
      // http://jsfiddle.net/NDYV8/16/

      ctx.globalCompositeOperation = 'multiply';
      ctx.fillStyle = 'rgb(255,0,255)';
      ctx.beginPath();
      ctx.arc(50, 50, 50, 0, Math.PI * 2, true);
      ctx.closePath();
      ctx.fill();
      ctx.fillStyle = 'rgb(0,255,255)';
      ctx.beginPath();
      ctx.arc(100, 50, 50, 0, Math.PI * 2, true);
      ctx.closePath();
      ctx.fill();
      ctx.fillStyle = 'rgb(255,255,0)';
      ctx.beginPath();
      ctx.arc(75, 100, 50, 0, Math.PI * 2, true);
      ctx.closePath();
      ctx.fill();
      ctx.fillStyle = 'rgb(255,0,255)'; // canvas winding
      // http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
      // http://jsfiddle.net/NDYV8/19/

      ctx.arc(75, 75, 75, 0, Math.PI * 2, true);
      ctx.arc(75, 75, 25, 0, Math.PI * 2, true);
      ctx.fill('evenodd');

      if (canvas.toDataURL) {
        result.push('canvas fp:' + canvas.toDataURL());
      }

      return result;
    };

    var getTouchSupport = function getTouchSupport() {
      var maxTouchPoints = 0;
      var touchEvent;

      if (typeof navigator.maxTouchPoints !== 'undefined') {
        maxTouchPoints = navigator.maxTouchPoints;
      } else if (typeof navigator.msMaxTouchPoints !== 'undefined') {
        maxTouchPoints = navigator.msMaxTouchPoints;
      }

      try {
        document.createEvent('TouchEvent');
        touchEvent = true;
      } catch (_) {
        touchEvent = false;
      }

      var touchStart = 'ontouchstart' in window;
      return [maxTouchPoints, touchEvent, touchStart];
    };

    var getWebglFp = function getWebglFp() {
      var gl;

      var fa2s = function fa2s(fa) {
        gl.clearColor(0.0, 0.0, 0.0, 1.0);
        gl.enable(gl.DEPTH_TEST);
        gl.depthFunc(gl.LEQUAL);
        gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
        return '[' + fa[0] + ', ' + fa[1] + ']';
      };

      var maxAnisotropy = function maxAnisotropy(gl) {
        var ext = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic');

        if (ext) {
          var anisotropy = gl.getParameter(ext.MAX_TEXTURE_MAX_ANISOTROPY_EXT);

          if (anisotropy === 0) {
            anisotropy = 2;
          }

          return anisotropy;
        } else {
          return null;
        }
      };

      gl = getWebglCanvas();

      if (!gl) {
        return null;
      } // WebGL fingerprinting is a combination of techniques, found in MaxMind antifraud script & Augur fingerprinting.
      // First it draws a gradient object with shaders and convers the image to the Base64 string.
      // Then it enumerates all WebGL extensions & capabilities and appends them to the Base64 string, resulting in a huge WebGL string, potentially very unique on each device
      // Since iOS supports webgl starting from version 8.1 and 8.1 runs on several graphics chips, the results may be different across ios devices, but we need to verify it.


      var result = [];
      var vShaderTemplate = 'attribute vec2 attrVertex;varying vec2 varyinTexCoordinate;uniform vec2 uniformOffset;void main(){varyinTexCoordinate=attrVertex+uniformOffset;gl_Position=vec4(attrVertex,0,1);}';
      var fShaderTemplate = 'precision mediump float;varying vec2 varyinTexCoordinate;void main() {gl_FragColor=vec4(varyinTexCoordinate,0,1);}';
      var vertexPosBuffer = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, vertexPosBuffer);
      var vertices = new Float32Array([-0.2, -0.9, 0, 0.4, -0.26, 0, 0, 0.732134444, 0]);
      gl.bufferData(gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW);
      vertexPosBuffer.itemSize = 3;
      vertexPosBuffer.numItems = 3;
      var program = gl.createProgram();
      var vshader = gl.createShader(gl.VERTEX_SHADER);
      gl.shaderSource(vshader, vShaderTemplate);
      gl.compileShader(vshader);
      var fshader = gl.createShader(gl.FRAGMENT_SHADER);
      gl.shaderSource(fshader, fShaderTemplate);
      gl.compileShader(fshader);
      gl.attachShader(program, vshader);
      gl.attachShader(program, fshader);
      gl.linkProgram(program);
      gl.useProgram(program);
      program.vertexPosAttrib = gl.getAttribLocation(program, 'attrVertex');
      program.offsetUniform = gl.getUniformLocation(program, 'uniformOffset');
      gl.enableVertexAttribArray(program.vertexPosArray);
      gl.vertexAttribPointer(program.vertexPosAttrib, vertexPosBuffer.itemSize, gl.FLOAT, !1, 0, 0);
      gl.uniform2f(program.offsetUniform, 1, 1);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, vertexPosBuffer.numItems);

      try {
        result.push(gl.canvas.toDataURL());
      } catch (e) {
        /* .toDataURL may be absent or broken (blocked by extension) */
      }

      result.push('extensions:' + (gl.getSupportedExtensions() || []).join(';'));
      result.push('webgl aliased line width range:' + fa2s(gl.getParameter(gl.ALIASED_LINE_WIDTH_RANGE)));
      result.push('webgl aliased point size range:' + fa2s(gl.getParameter(gl.ALIASED_POINT_SIZE_RANGE)));
      result.push('webgl alpha bits:' + gl.getParameter(gl.ALPHA_BITS));
      result.push('webgl antialiasing:' + (gl.getContextAttributes().antialias ? 'yes' : 'no'));
      result.push('webgl blue bits:' + gl.getParameter(gl.BLUE_BITS));
      result.push('webgl depth bits:' + gl.getParameter(gl.DEPTH_BITS));
      result.push('webgl green bits:' + gl.getParameter(gl.GREEN_BITS));
      result.push('webgl max anisotropy:' + maxAnisotropy(gl));
      result.push('webgl max combined texture image units:' + gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS));
      result.push('webgl max cube map texture size:' + gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE));
      result.push('webgl max fragment uniform vectors:' + gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS));
      result.push('webgl max render buffer size:' + gl.getParameter(gl.MAX_RENDERBUFFER_SIZE));
      result.push('webgl max texture image units:' + gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS));
      result.push('webgl max texture size:' + gl.getParameter(gl.MAX_TEXTURE_SIZE));
      result.push('webgl max varying vectors:' + gl.getParameter(gl.MAX_VARYING_VECTORS));
      result.push('webgl max vertex attribs:' + gl.getParameter(gl.MAX_VERTEX_ATTRIBS));
      result.push('webgl max vertex texture image units:' + gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS));
      result.push('webgl max vertex uniform vectors:' + gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS));
      result.push('webgl max viewport dims:' + fa2s(gl.getParameter(gl.MAX_VIEWPORT_DIMS)));
      result.push('webgl red bits:' + gl.getParameter(gl.RED_BITS));
      result.push('webgl renderer:' + gl.getParameter(gl.RENDERER));
      result.push('webgl shading language version:' + gl.getParameter(gl.SHADING_LANGUAGE_VERSION));
      result.push('webgl stencil bits:' + gl.getParameter(gl.STENCIL_BITS));
      result.push('webgl vendor:' + gl.getParameter(gl.VENDOR));
      result.push('webgl version:' + gl.getParameter(gl.VERSION));

      try {
        // Add the unmasked vendor and unmasked renderer if the debug_renderer_info extension is available
        var extensionDebugRendererInfo = gl.getExtension('WEBGL_debug_renderer_info');

        if (extensionDebugRendererInfo) {
          result.push('webgl unmasked vendor:' + gl.getParameter(extensionDebugRendererInfo.UNMASKED_VENDOR_WEBGL));
          result.push('webgl unmasked renderer:' + gl.getParameter(extensionDebugRendererInfo.UNMASKED_RENDERER_WEBGL));
        }
      } catch (e) {
        /* squelch */
      }

      if (!gl.getShaderPrecisionFormat) {
        loseWebglContext(gl);
        return result;
      }

      each(['FLOAT', 'INT'], function (numType) {
        each(['VERTEX', 'FRAGMENT'], function (shader) {
          each(['HIGH', 'MEDIUM', 'LOW'], function (numSize) {
            each(['precision', 'rangeMin', 'rangeMax'], function (key) {
              var format = gl.getShaderPrecisionFormat(gl[shader + '_SHADER'], gl[numSize + '_' + numType])[key];

              if (key !== 'precision') {
                key = 'precision ' + key;
              }

              var line = ['webgl ', shader.toLowerCase(), ' shader ', numSize.toLowerCase(), ' ', numType.toLowerCase(), ' ', key, ':', format].join('');
              result.push(line);
            });
          });
        });
      });
      loseWebglContext(gl);
      return result;
    };

    var getWebglVendorAndRenderer = function getWebglVendorAndRenderer() {
      /* This a subset of the WebGL fingerprint with a lot of entropy, while being reasonably browser-independent */
      try {
        var glContext = getWebglCanvas();
        var extensionDebugRendererInfo = glContext.getExtension('WEBGL_debug_renderer_info');
        var params = glContext.getParameter(extensionDebugRendererInfo.UNMASKED_VENDOR_WEBGL) + '~' + glContext.getParameter(extensionDebugRendererInfo.UNMASKED_RENDERER_WEBGL);
        loseWebglContext(glContext);
        return params;
      } catch (e) {
        return null;
      }
    };

    var getAdBlock = function getAdBlock() {
      var ads = document.createElement('div');
      ads.innerHTML = '&nbsp;';
      ads.className = 'adsbox';
      var result = false;

      try {
        // body may not exist, that's why we need try/catch
        document.body.appendChild(ads);
        result = document.getElementsByClassName('adsbox')[0].offsetHeight === 0;
        document.body.removeChild(ads);
      } catch (e) {
        result = false;
      }

      return result;
    };

    var getHasLiedLanguages = function getHasLiedLanguages() {
      // We check if navigator.language is equal to the first language of navigator.languages
      // navigator.languages is undefined on IE11 (and potentially older IEs)
      if (typeof navigator.languages !== 'undefined') {
        try {
          var firstLanguages = navigator.languages[0].substr(0, 2);

          if (firstLanguages !== navigator.language.substr(0, 2)) {
            return true;
          }
        } catch (err) {
          return true;
        }
      }

      return false;
    };

    var getHasLiedResolution = function getHasLiedResolution() {
      return window.screen.width < window.screen.availWidth || window.screen.height < window.screen.availHeight;
    };

    var getHasLiedOs = function getHasLiedOs() {
      var userAgent = navigator.userAgent.toLowerCase();
      var oscpu = navigator.oscpu;
      var platform = navigator.platform.toLowerCase();
      var os; // We extract the OS from the user agent (respect the order of the if else if statement)

      if (userAgent.indexOf('windows phone') >= 0) {
        os = 'Windows Phone';
      } else if (userAgent.indexOf('windows') >= 0 || userAgent.indexOf('win16') >= 0 || userAgent.indexOf('win32') >= 0 || userAgent.indexOf('win64') >= 0 || userAgent.indexOf('win95') >= 0 || userAgent.indexOf('win98') >= 0 || userAgent.indexOf('winnt') >= 0 || userAgent.indexOf('wow64') >= 0) {
        os = 'Windows';
      } else if (userAgent.indexOf('android') >= 0) {
        os = 'Android';
      } else if (userAgent.indexOf('linux') >= 0 || userAgent.indexOf('cros') >= 0 || userAgent.indexOf('x11') >= 0) {
        os = 'Linux';
      } else if (userAgent.indexOf('iphone') >= 0 || userAgent.indexOf('ipad') >= 0 || userAgent.indexOf('ipod') >= 0 || userAgent.indexOf('crios') >= 0 || userAgent.indexOf('fxios') >= 0) {
        os = 'iOS';
      } else if (userAgent.indexOf('macintosh') >= 0 || userAgent.indexOf('mac_powerpc)') >= 0) {
        os = 'Mac';
      } else {
        os = 'Other';
      } // We detect if the person uses a touch device


      var mobileDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

      if (mobileDevice && os !== 'Windows' && os !== 'Windows Phone' && os !== 'Android' && os !== 'iOS' && os !== 'Other' && userAgent.indexOf('cros') === -1) {
        return true;
      } // We compare oscpu with the OS extracted from the UA


      if (typeof oscpu !== 'undefined') {
        oscpu = oscpu.toLowerCase();

        if (oscpu.indexOf('win') >= 0 && os !== 'Windows' && os !== 'Windows Phone') {
          return true;
        } else if (oscpu.indexOf('linux') >= 0 && os !== 'Linux' && os !== 'Android') {
          return true;
        } else if (oscpu.indexOf('mac') >= 0 && os !== 'Mac' && os !== 'iOS') {
          return true;
        } else if ((oscpu.indexOf('win') === -1 && oscpu.indexOf('linux') === -1 && oscpu.indexOf('mac') === -1) !== (os === 'Other')) {
          return true;
        }
      } // We compare platform with the OS extracted from the UA


      if (platform.indexOf('win') >= 0 && os !== 'Windows' && os !== 'Windows Phone') {
        return true;
      } else if ((platform.indexOf('linux') >= 0 || platform.indexOf('android') >= 0 || platform.indexOf('pike') >= 0) && os !== 'Linux' && os !== 'Android') {
        return true;
      } else if ((platform.indexOf('mac') >= 0 || platform.indexOf('ipad') >= 0 || platform.indexOf('ipod') >= 0 || platform.indexOf('iphone') >= 0) && os !== 'Mac' && os !== 'iOS') {
        return true;
      } else if (platform.indexOf('arm') >= 0 && os === 'Windows Phone') {
        return false;
      } else if (platform.indexOf('pike') >= 0 && userAgent.indexOf('opera mini') >= 0) {
        return false;
      } else {
        var platformIsOther = platform.indexOf('win') < 0 && platform.indexOf('linux') < 0 && platform.indexOf('mac') < 0 && platform.indexOf('iphone') < 0 && platform.indexOf('ipad') < 0 && platform.indexOf('ipod') < 0;

        if (platformIsOther !== (os === 'Other')) {
          return true;
        }
      }

      return typeof navigator.plugins === 'undefined' && os !== 'Windows' && os !== 'Windows Phone';
    };

    var getHasLiedBrowser = function getHasLiedBrowser() {
      var userAgent = navigator.userAgent.toLowerCase();
      var productSub = navigator.productSub; // we extract the browser from the user agent (respect the order of the tests)

      var browser;

      if (userAgent.indexOf('edge/') >= 0 || userAgent.indexOf('iemobile/') >= 0) {
        // Unreliable, different versions use EdgeHTML, Webkit, Blink, etc.
        return false;
      } else if (userAgent.indexOf('opera mini') >= 0) {
        // Unreliable, different modes use Presto, WebView, Webkit, etc.
        return false;
      } else if (userAgent.indexOf('firefox/') >= 0) {
        browser = 'Firefox';
      } else if (userAgent.indexOf('opera/') >= 0 || userAgent.indexOf(' opr/') >= 0) {
        browser = 'Opera';
      } else if (userAgent.indexOf('chrome/') >= 0) {
        browser = 'Chrome';
      } else if (userAgent.indexOf('safari/') >= 0) {
        if (userAgent.indexOf('android 1.') >= 0 || userAgent.indexOf('android 2.') >= 0 || userAgent.indexOf('android 3.') >= 0 || userAgent.indexOf('android 4.') >= 0) {
          browser = 'AOSP';
        } else {
          browser = 'Safari';
        }
      } else if (userAgent.indexOf('trident/') >= 0) {
        browser = 'Internet Explorer';
      } else {
        browser = 'Other';
      }

      if ((browser === 'Chrome' || browser === 'Safari' || browser === 'Opera') && productSub !== '20030107') {
        return true;
      } // eslint-disable-next-line no-eval


      var tempRes = eval.toString().length;

      if (tempRes === 37 && browser !== 'Safari' && browser !== 'Firefox' && browser !== 'Other') {
        return true;
      } else if (tempRes === 39 && browser !== 'Internet Explorer' && browser !== 'Other') {
        return true;
      } else if (tempRes === 33 && browser !== 'Chrome' && browser !== 'AOSP' && browser !== 'Opera' && browser !== 'Other') {
        return true;
      } // We create an error to see how it is handled


      var errFirefox;

      try {
        // eslint-disable-next-line no-throw-literal
        throw 'a';
      } catch (err) {
        try {
          err.toSource();
          errFirefox = true;
        } catch (errOfErr) {
          errFirefox = false;
        }
      }

      return errFirefox && browser !== 'Firefox' && browser !== 'Other';
    };

    var isCanvasSupported = function isCanvasSupported() {
      var elem = document.createElement('canvas');
      return !!(elem.getContext && elem.getContext('2d'));
    };

    var isWebGlSupported = function isWebGlSupported() {
      // code taken from Modernizr
      if (!isCanvasSupported()) {
        return false;
      }

      var glContext = getWebglCanvas();
      var isSupported = !!window.WebGLRenderingContext && !!glContext;
      loseWebglContext(glContext);
      return isSupported;
    }; // var isIE = function () {
    //   if (navigator.appName === 'Microsoft Internet Explorer') {
    //     return true
    //   } else if (navigator.appName === 'Netscape' && /Trident/.test(navigator.userAgent)) { // IE 11
    //     return true
    //   }
    //   return false
    // }
    // var hasSwfObjectLoaded = function () {
    //   return typeof window.swfobject !== 'undefined'
    // }
    // var hasMinFlashInstalled = function () {
    //   return window.swfobject.hasFlashPlayerVersion('9.0.0')
    // }
    // var addFlashDivNode = function (options) {
    //   var node = document.createElement('div')
    //   node.setAttribute('id', options.fonts.swfContainerId)
    //   document.body.appendChild(node)
    // }
    // var loadSwfAndDetectFonts = function (done, options) {
    //   var hiddenCallback = '___fp_swf_loaded'
    //   window[hiddenCallback] = function (fonts) {
    //     done(fonts)
    //   }
    //   var id = options.fonts.swfContainerId
    //   addFlashDivNode()
    //   var flashvars = { onReady: hiddenCallback }
    //   var flashparams = { allowScriptAccess: 'always', menu: 'false' }
    //   window.swfobject.embedSWF(options.fonts.swfPath, id, '1', '1', '9.0.0', false, flashvars, flashparams, {})
    // }


    var getWebglCanvas = function getWebglCanvas() {
      var canvas = document.createElement('canvas');
      var gl = null;

      try {
        gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
      } catch (e) {
        /* squelch */
      }

      if (!gl) {
        gl = null;
      }

      return gl;
    };

    var loseWebglContext = function loseWebglContext(context) {
      var loseContextExtension = context.getExtension('WEBGL_lose_context');

      if (loseContextExtension != null) {
        loseContextExtension.loseContext();
      }
    };

    var canvasKey = function canvasKey(done, options) {
      if (isCanvasSupported()) {
        done(getCanvasFp(options));
        return;
      }

      done(options.NOT_AVAILABLE);
    };

    var webglKey = function webglKey(done, options) {
      if (isWebGlSupported()) {
        done(getWebglFp());
        return;
      }

      done(options.NOT_AVAILABLE);
    };

    var adBlockKey = function adBlockKey(done) {
      done(getAdBlock());
    };

    var hasLiedLanguagesKey = function hasLiedLanguagesKey(done) {
      done(getHasLiedLanguages());
    };

    var hasLiedResolutionKey = function hasLiedResolutionKey(done) {
      done(getHasLiedResolution());
    };

    var hasLiedOsKey = function hasLiedOsKey(done) {
      done(getHasLiedOs());
    };

    var hasLiedBrowserKey = function hasLiedBrowserKey(done) {
      done(getHasLiedBrowser());
    };

    var touchSupportKey = function touchSupportKey(done) {
      done(getTouchSupport());
    };

    var webglVendorAndRendererKey = function webglVendorAndRendererKey(done) {
      if (isWebGlSupported()) {
        done(getWebglVendorAndRenderer());
        return;
      }

      done();
    };

    var components = [{
      key: 'canvas',
      getData: canvasKey
    }, {
      key: 'webgl',
      getData: webglKey
    }, {
      key: 'webglVendorAndRenderer',
      getData: webglVendorAndRendererKey
    }, {
      key: 'adBlock',
      getData: adBlockKey
    }, {
      key: 'hasLiedLanguages',
      getData: hasLiedLanguagesKey
    }, {
      key: 'hasLiedResolution',
      getData: hasLiedResolutionKey
    }, {
      key: 'hasLiedOs',
      getData: hasLiedOsKey
    }, {
      key: 'hasLiedBrowser',
      getData: hasLiedBrowserKey
    }, {
      key: 'touchSupport',
      getData: touchSupportKey
    }];

    var Fingerprint2 = function Fingerprint2(options) {
      throw new Error("'new Fingerprint()' is deprecated, see https://github.com/Valve/fingerprintjs2#upgrade-guide-from-182-to-200");
    };

    Fingerprint2.get = function (options, callback) {
      if (!callback) {
        callback = options;
        options = {};
      } else if (!options) {
        options = {};
      }

      extendSoft(options, defaultOptions);
      options.components = options.extraComponents.concat(components);
      var keys = {
        data: [],
        addPreprocessedComponent: function addPreprocessedComponent(key, value) {
          if (typeof options.preprocessor === 'function') {
            value = options.preprocessor(key, value);
          }

          keys.data.push({
            key: key,
            value: value
          });
        }
      };
      var i = -1;

      var chainComponents = function chainComponents(alreadyWaited) {
        i += 1;

        if (i >= options.components.length) {
          // on finish
          callback(keys.data);
          return;
        }

        var component = options.components[i];

        if (options.excludes[component.key]) {
          chainComponents(false); // skip

          return;
        }

        if (!alreadyWaited && component.pauseBefore) {
          i -= 1;
          setTimeout(function () {
            chainComponents(true);
          }, 1);
          return;
        }

        try {
          component.getData(function (value) {
            keys.addPreprocessedComponent(component.key, value);
            chainComponents(false);
          }, options);
        } catch (error) {
          // main body error
          keys.addPreprocessedComponent(component.key, String(error));
          chainComponents(false);
        }
      };

      chainComponents(false);
    };

    Fingerprint2.getPromise = function (options) {
      return new Promise(function (resolve, reject) {
        Fingerprint2.get(options, resolve);
      });
    };

    Fingerprint2.getV18 = function (options, callback) {
      if (callback == null) {
        callback = options;
        options = {};
      }

      return Fingerprint2.get(options, function (components) {
        var newComponents = [];

        for (var i = 0; i < components.length; i++) {
          var component = components[i];

          if (component.value === (options.NOT_AVAILABLE || 'not available')) {
            newComponents.push({
              key: component.key,
              value: 'unknown'
            });
          } else if (component.key === 'plugins') {
            newComponents.push({
              key: 'plugins',
              value: map(component.value, function (p) {
                var mimeTypes = map(p[2], function (mt) {
                  if (mt.join) {
                    return mt.join('~');
                  }

                  return mt;
                }).join(',');
                return [p[0], p[1], mimeTypes].join('::');
              })
            });
          } else if (['canvas', 'webgl'].indexOf(component.key) !== -1 && Array.isArray(component.value)) {
            // sometimes WebGL returns error in headless browsers (during CI testing for example)
            // so we need to join only if the values are array
            newComponents.push({
              key: component.key,
              value: component.value.join('~')
            });
          } else if (['sessionStorage', 'localStorage', 'indexedDb', 'addBehavior', 'openDatabase'].indexOf(component.key) !== -1) {
            if (component.value) {
              newComponents.push({
                key: component.key,
                value: 1
              });
            } else {
              // skip
              continue;
            }
          } else {
            if (component.value) {
              newComponents.push(component.value.join ? {
                key: component.key,
                value: component.value.join(';')
              } : component);
            } else {
              newComponents.push({
                key: component.key,
                value: component.value
              });
            }
          }
        }

        var murmur = x64hash128(map(newComponents, function (component) {
          return component.value;
        }).join('~~~'), 31);
        callback(murmur, newComponents);
      });
    };

    Fingerprint2.x64hash128 = x64hash128;
    Fingerprint2.VERSION = '2.1.0';
    return Fingerprint2;
  });
});

var log$1 = debug('xpedeo-core:device');
debug.enable(process.env.VUE_APP_DEBUG);
var Device = {
  __platform: process.env.VUE_APP_PLATFORM,
  __isLoan: process.env.VUE_APP_IS_LOAN_DEVICE,
  __deviceId: null,
  __$xp: null,

  get platform() {
    return this.__platform;
  },

  get isLoan() {
    return this.__isLoan;
  },

  get deviceId() {
    return this.__deviceId;
  },

  get isIPhoneOrPad() {
    var UA = window.navigator.userAgent.toLowerCase();
    return UA && /iphone|ipad/.test(UA);
  },

  get isTouchDevice() {
    return 'ontouchstart' in document.documentElement;
  },

  getUuid: function () {
    var _getUuid = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!this.__deviceId) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", this.__deviceId);

            case 4:
              this.__deviceId = window.localStorage.getItem('deviceId');

              if (!(this.__deviceId !== null)) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return", this.__deviceId);

            case 9:
              if (!(this.__platform === 'browser')) {
                _context.next = 15;
                break;
              }

              _context.next = 12;
              return this.generateFingerprint();

            case 12:
              return _context.abrupt("return", this.__deviceId);

            case 15:
              if (!window.device) {
                _context.next = 20;
                break;
              }

              this.__deviceId = window.device.uuid;
              window.localStorage.setItem('deviceId', this.__deviceId);
              log$1('In user app|loan device, setting deviceId');
              return _context.abrupt("return", this.__deviceId);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function getUuid() {
      return _getUuid.apply(this, arguments);
    }

    return getUuid;
  }(),
  goToAdminActivity: function () {
    var _goToAdminActivity2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              log$1('goToAdminActivity()');
              _context2.next = 3;
              return goToAdminActivity();

            case 3:
              log$1('goToAdminActivity() success');

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function goToAdminActivity$1() {
      return _goToAdminActivity2.apply(this, arguments);
    }

    return goToAdminActivity$1;
  }(),
  checkLocationSettings: function () {
    var _checkLocationSettings2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              log$1('checkLocationSettings()');
              _context3.prev = 1;
              _context3.next = 4;
              return checkLocationSettings();

            case 4:
              _context3.next = 10;
              break;

            case 6:
              _context3.prev = 6;
              _context3.t0 = _context3["catch"](1);
              console.error(_context3.t0);
              return _context3.abrupt("return", false);

            case 10:
              log$1('checkLocationSettings() success');
              return _context3.abrupt("return", true);

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 6]]);
    }));

    function checkLocationSettings$1() {
      return _checkLocationSettings2.apply(this, arguments);
    }

    return checkLocationSettings$1;
  }(),
  getRemappedUrl: function () {
    var _getRemappedUrl2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(url) {
      var remappedUrl;
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              log$1('getRemappedUrl()');
              _context4.next = 3;
              return getRemappedUrl(url);

            case 3:
              remappedUrl = _context4.sent;
              log$1('getRemappedUrl() success');
              return _context4.abrupt("return", remappedUrl);

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    function getRemappedUrl$1(_x) {
      return _getRemappedUrl2.apply(this, arguments);
    }

    return getRemappedUrl$1;
  }(),
  checkPermissions: function () {
    var _checkPermissions2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5() {
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              log$1('checkPermissions()');
              _context5.next = 3;
              return checkPermissions();

            case 3:
              log$1('checkPermissions() success');

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    function checkPermissions$1() {
      return _checkPermissions2.apply(this, arguments);
    }

    return checkPermissions$1;
  }(),
  generateFingerprint: function () {
    var _generateFingerprint = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6() {
      var _this = this;

      var getFingerprint;
      return regenerator.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              getFingerprint = function getFingerprint() {
                fingerprint.get(function (components) {
                  var values = components.map(function (component) {
                    return component.value;
                  });
                  var murmur = fingerprint.x64hash128(values.join(''), 31);
                  log$1('murmur hash(DeviceId):', murmur);
                  _this.__deviceId = murmur;
                  window.localStorage.setItem('deviceId', murmur);
                });
              };

              if (window.requestIdleCallback) {
                requestIdleCallback(getFingerprint);
              } else {
                setTimeout(getFingerprint, 500);
              }

            case 2:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    function generateFingerprint() {
      return _generateFingerprint.apply(this, arguments);
    }

    return generateFingerprint;
  }(),
  getDeviceTimeOffset: function getDeviceTimeOffset$1() {
    if (process.env.VUE_APP_IS_LOAN_DEVICE) {
      return getDeviceTimeOffset();
    } else {
      log$1('getDeviceTimeOffset() NOT A LOAN DEVICE');
      return 0;
    }
  },
  install: function install(Vue, opts, $xp, cfg) {
    if ($xp.deviceInstalled) {
      return;
    }

    this.__$xp = $xp;
    $xp.deviceInstalled = true;
    Vue.util.defineReactive($xp, 'device', this);
  }
};

/**
 * Throttling enforces a maximum number of times a function can be called over time. As in “execute this function at most once every X milliseconds.”.
 * see http://demo.nimius.net/debounce_throttle/
 *
 * @param {function} fn throttled function
 * @param {integer} limit in milliseconds
 */
function throttle (fn) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var wait = false;
  var result;
  return function ()
  /* ...args */
  {
    if (wait === false) {
      wait = true;
      setTimeout(function () {
        wait = false;
      }, limit);
      result = fn.apply(this, arguments);
    }

    return result;
  };
}

var log$2 = debug('xpedeo-core:navigation');
debug.enable(process.env.VUE_APP_DEBUG);
var showNavCounter = 0;
var Navigation = {
  __isNavHidden: false,
  __isAutoHideAllowed: false,
  __isChildPagesMenuHidden: true,
  __$xp: null,
  isEventConsumerEnabled: false,
  // __isAudioControlAutoHideAllowed: true,
  isFullScreen: false,
  entriesIdList: [],
  currentEntryIndex: 0,
  isAudioSynced: false,
  entryNavDirection: '',
  __tabs: [],
  __activeTabId: null,
  __childPagesMenuItems: [],

  get isNavHidden() {
    return this.__isNavHidden;
  },

  get isAutoHideAllowed() {
    return this.__isAutoHideAllowed;
  },

  get isChildPagesMenuHidden() {
    return this.__isChildPagesMenuHidden;
  },

  get hasPreviousEntry() {
    return this.currentEntryIndex > 0;
  },

  get hasNextEntry() {
    return this.currentEntryIndex < this.entriesIdList.length - 1;
  },

  // get isAudioControlAutoHideAllowed () {
  //   return this.__isAudioControlAutoHideAllowed
  // },
  get currentEntry() {
    return this.entriesIdList[this.currentEntryIndex];
  },

  get isEntryNavVisible() {
    return !this.isAudioSynced && this.entriesIdList.length > 1 && this.isFullScreen;
  },

  // set autoHideAudioControl (value) {
  //   this.__isAudioControlAutoHideAllowed = value
  // },
  get tabs() {
    return this.__tabs;
  },

  get activeTabId() {
    return this.__activeTabId;
  },

  get childPagesMenuItems() {
    return this.__childPagesMenuItems;
  },

  toggleChildPagesMenu: function toggleChildPagesMenu() {
    this.__isChildPagesMenuHidden = !this.__isChildPagesMenuHidden;
  },
  allowAutoHide: function allowAutoHide() {
    log$2('allow auto hide');
    this.__isAutoHideAllowed = true;
  },
  preventAutoHide: function preventAutoHide() {
    log$2('prevent auto hide');
    this.__isAutoHideAllowed = false;
  },
  // allowAudioControlAutoHide () {
  //   this.__isAudioControlAutoHideAllowed = true
  // },
  preventAudioControlAutoHide: function preventAudioControlAutoHide() {
    this.__isAudioControlAutoHideAllowed = false;
  },
  initEntriesIdList: function initEntriesIdList(list) {
    this.entriesIdList = list;
    this.entryNavDirection = null;
    this.currentEntryIndex = 0;
  },
  goToNextEntry: function goToNextEntry() {
    this.entryNavDirection = 'next';
    this.currentEntryIndex = Math.abs((this.currentEntryIndex + 1) % this.entriesIdList.length);
  },
  goToPreviousEntry: function goToPreviousEntry() {
    this.entryNavDirection = 'previous';
    var index = (this.currentEntryIndex - 1) % this.entriesIdList.length;

    if (index < 0) {
      index += this.entriesIdList.length;
    }

    this.currentEntryIndex = index;
  },
  goToEntry: function goToEntry(entryId) {
    this.currentEntryIndex = this.entriesIdList.indexOf(entryId);
  },

  /**
   * show Navigation
   * @param duration: (undefined: do not autohide, number: autohide after milliseconds, true: autohide after default autoHideNavDuration)
   */
  showNav: function showNav(duration) {
    var _this = this;

    duration = duration === true ? this.__$xp.settings.mergedSettings.navigation.autoHideNavDuration : duration; // Ausnahme SplashScreen:

    if (this.__$xp.content && this.__$xp.content.pageData && this.__$xp.content.pageData.Class === 'XpSplashScreen') {
      this.__isNavHidden = true;
      this.preventAutoHide();
      return;
    }

    clearTimeout(showNavCounter);
    this.__isNavHidden = false;

    if (duration && this.isAutoHideAllowed) {
      showNavCounter = setTimeout(function () {
        _this.__isNavHidden = true;
      }, duration);
    }
  },
  hideNav: function hideNav() {
    clearTimeout(showNavCounter);
    this.__isNavHidden = true;
  },
  setTabs: function setTabs(tabs) {
    this.__tabs = tabs;
  },
  resetTabs: function resetTabs() {
    this.__tabs = [];
    this.__activeTabId = null;
  },
  setActiveTabId: function setActiveTabId(tabId) {
    if (this.__activeTabId !== parseInt(tabId)) {
      this.__activeTabId = parseInt(tabId);
    }
  },
  setChildPagesMenuItems: function setChildPagesMenuItems(items) {
    this.__childPagesMenuItems = items;
  },
  resetChildPagesMenuItems: function resetChildPagesMenuItems() {
    this.__childPagesMenuItems = [];
  },
  initializeTouchEvents: function initializeTouchEvents() {
    var _this2 = this;

    var onTouchStart = function onTouchStart(e) {
      // console.log('onTouchStart()', e)
      if (_this2.__$xp.navigation.isAutoHideAllowed) {
        _this2.__$xp.navigation.showNav();
      }

      _this2.__$xp.screen.postponeDim();
      /*
        iPhones starting with iOS10 ignore "user-scalable=no" "to improve accessibility"
        To prevent pinch zooming the whole site, we ignore multi-touch-events if the event is not handled before.
       */


      if (_this2.__$xp.device.isIPhoneOrPad) {
        if (!e.handled && e.touches.length > 1) {
          e.preventDefault();
        }
      }
    };

    var onTouchEnd = function onTouchEnd(e) {
      // console.log('onTouchEnd()', e)
      if (_this2.__$xp.device.platform === 'browser' && !_this2.__$xp.device.isIPhoneOrPad) {
        _this2.__$xp.screen.requestFullscreen();
      }

      if (_this2.__$xp.navigation.isAutoHideAllowed) {
        _this2.__$xp.navigation.showNav(true);
      }
      /*
        iPhones starting with iOS10 ignore "user-scalable=no" "to improve accessibility"
        To prevent zooming the whole site on double click, we ignore double clicks.
       */


      if (_this2.__$xp.device.isIPhoneOrPad) {
        var now = new Date().getTime();

        if (now - _this2.lastTouchEnd <= 300) {
          e.preventDefault();
        }

        _this2.lastTouchEnd = now;
      }
    };

    var onTouchEndHandler = throttle(onTouchEnd, 100);
    var onTouchStartHandler = throttle(onTouchStart, 100);
    window.addEventListener('touchstart', onTouchStartHandler, false);
    window.addEventListener('mousedown', onTouchStartHandler, false);
    window.addEventListener('touchend', onTouchEndHandler, false);
    window.addEventListener('mouseup', onTouchEndHandler, false);
  },
  install: function install(Vue, opts, $xp, cfg) {
    if ($xp.navigationInstalled) {
      return;
    }

    $xp.navigationInstalled = true;
    this.__$xp = $xp;
    this.initializeTouchEvents();
    Vue.util.defineReactive($xp, 'navigation', this);
  }
};

var Battery = {
  __isPlugged: null,
  __level: 0,
  __$xp: null,
  __$router: null,

  get level() {
    return this.__level;
  },

  get isPlugged() {
    return this.__isPlugged;
  },

  setBatteryStatus: function setBatteryStatus(status) {
    this.__isPlugged = status.isPlugged;
    this.__level = status.level;
  },
  startListening: function startListening(handler) {
    window.addEventListener('batterystatus', handler, false);
  },
  stopListening: function stopListening(handler) {
    window.removeEventListener('batterystatus', handler, false);
  },
  init: function init() {
    this.__$xp.device.isLoan && this.startListening(this.onBatteryStatus.bind(this));
  },
  onBatteryStatus: function onBatteryStatus(status) {
    if (this.__$xp.device.platform === 'android') {
      if (this.isPlugged !== null) {
        if (!this.isPlugged && status.isPlugged) {
          this.__$router.replace('/dock');
        } else if (this.isPlugged && !status.isPlugged && this.__$router.currentRoute.path === '/dock') {
          this.__$router.push('/');
        }
      }

      this.setBatteryStatus({
        isPlugged: status.isPlugged,
        level: status.level
      });
    }
  },
  install: function install(Vue, opts, $xp, cfg) {
    if ($xp.batteryInstalled) {
      return;
    }

    $xp.batteryInstalled = true;
    this.__$xp = $xp;
    this.__$router = opts.router;
    Vue.util.defineReactive($xp, 'battery', this);
  }
};

var lockWifiOn = function lockWifiOn(lockId) {
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_IS_LOAN_DEVICE) {
      window.XpedeoPreloader.lockWifiOn(lockId, function (locks) {
        resolve(locks);
      }, function (errMsg) {
        reject(new Error(errMsg));
      });
    } else {
      resolve([]);
    }
  });
};

var releaseWifiOn = function releaseWifiOn(lockId) {
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_IS_LOAN_DEVICE) {
      window.XpedeoPreloader.releaseWifiOn(lockId, function (locks) {
        resolve(locks);
      }, function (errMsg) {
        reject(new Error(errMsg));
      });
    } else {
      resolve([]);
    }
  });
};

var lockWifiConnectionOn = function lockWifiConnectionOn(lockId) {
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_IS_LOAN_DEVICE) {
      window.XpedeoPreloader.lockWifiConnectionOn(lockId, function (locks) {
        resolve(locks);
      }, function (errMsg) {
        reject(new Error(errMsg));
      });
    } else {
      resolve([]);
    }
  });
};

var releaseWifiConnectionOn = function releaseWifiConnectionOn(lockId) {
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_IS_LOAN_DEVICE) {
      window.XpedeoPreloader.releaseWifiConnectionOn(lockId, function (locks) {
        resolve(locks);
      }, function (errMsg) {
        reject(new Error(errMsg));
      });
    } else {
      resolve([]);
    }
  });
};

var isWifiEnabled = function isWifiEnabled() {
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_IS_LOAN_DEVICE) {
      window.XpedeoPreloader.isWifiEnabled(function () {
        resolve();
      }, function (errMsg) {
        reject(new Error(errMsg));
      });
    } else {
      resolve();
    }
  });
};

var getConnectedSSID = function getConnectedSSID() {
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_IS_LOAN_DEVICE) {
      window.XpedeoPreloader.getConnectedSSID(function (ssid) {
        resolve(ssid);
      }, function (errorMsg) {
        reject(new Error(errorMsg));
      });
    } else {
      resolve();
    }
  });
};

var wifiFacad = {
  lockWifiOn: lockWifiOn,
  releaseWifiOn: releaseWifiOn,
  lockWifiConnectionOn: lockWifiConnectionOn,
  releaseWifiConnectionOn: releaseWifiConnectionOn,
  isWifiEnabled: isWifiEnabled,
  getConnectedSSID: getConnectedSSID
};

var log$3 = debug('xpedeo-core:wifi');
debug.enable(process.env.VUE_APP_DEBUG);
var Wifi = {
  __locks: [],

  get locks() {
    return this.__locks;
  },

  lockWifiOn: function () {
    var _lockWifiOn = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(callerLockId) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              log$3("lockWifiOn(".concat(callerLockId, ")"));
              _context.prev = 1;
              _context.next = 4;
              return wifiFacad.lockWifiOn(callerLockId);

            case 4:
              this.__locks = _context.sent;
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);
              log$3('lockWifiOn error', _context.t0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[1, 7]]);
    }));

    function lockWifiOn(_x) {
      return _lockWifiOn.apply(this, arguments);
    }

    return lockWifiOn;
  }(),
  releaseWifiOn: function () {
    var _releaseWifiOn = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(callerLockId) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              log$3("releaseWifiOn(".concat(callerLockId, ")"));
              _context2.prev = 1;
              _context2.next = 4;
              return wifiFacad.releaseWifiOn(callerLockId);

            case 4:
              this.__locks = _context2.sent;
              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](1);
              log$3('releaseWifiOn error', _context2.t0);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[1, 7]]);
    }));

    function releaseWifiOn(_x2) {
      return _releaseWifiOn.apply(this, arguments);
    }

    return releaseWifiOn;
  }(),
  lockWifiConnectionOn: function () {
    var _lockWifiConnectionOn = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(callerLockId) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              log$3("lockWifiConnectionOn(".concat(callerLockId, ")"));
              _context3.prev = 1;
              _context3.next = 4;
              return wifiFacad.lockWifiConnectionOn(callerLockId);

            case 4:
              this.__locks = _context3.sent;
              _context3.next = 10;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](1);
              log$3('lockWifiConnectionOn error', _context3.t0);

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this, [[1, 7]]);
    }));

    function lockWifiConnectionOn(_x3) {
      return _lockWifiConnectionOn.apply(this, arguments);
    }

    return lockWifiConnectionOn;
  }(),
  releaseWifiConnectionOn: function () {
    var _releaseWifiConnectionOn = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(callerLockId) {
      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              log$3("releaseWifiConnectionOn(".concat(callerLockId, ")"));
              _context4.prev = 1;
              _context4.next = 4;
              return wifiFacad.releaseWifiConnectionOn(callerLockId);

            case 4:
              this.__locks = _context4.sent;
              _context4.next = 10;
              break;

            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](1);
              log$3('releaseWifiConnectionOn error', _context4.t0);

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this, [[1, 7]]);
    }));

    function releaseWifiConnectionOn(_x4) {
      return _releaseWifiConnectionOn.apply(this, arguments);
    }

    return releaseWifiConnectionOn;
  }(),
  isWifiEnabled: function () {
    var _isWifiEnabled = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5() {
      var isEnabled;
      return regenerator.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              log$3("isWifiEnabled()");
              _context5.prev = 1;
              _context5.next = 4;
              return wifiFacad.isWifiEnabled();

            case 4:
              isEnabled = _context5.sent;
              log$3("isWifiEnabled() success");
              return _context5.abrupt("return", isEnabled);

            case 9:
              _context5.prev = 9;
              _context5.t0 = _context5["catch"](1);
              log$3('releaseWifiConnectionOn error', _context5.t0);

            case 12:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[1, 9]]);
    }));

    function isWifiEnabled() {
      return _isWifiEnabled.apply(this, arguments);
    }

    return isWifiEnabled;
  }(),
  waitForWifi: function waitForWifi() {
    var _this = this;

    var timeoutMilliseconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10000;
    log$3("waitForWifi(".concat(timeoutMilliseconds, ")"));
    return new Promise(function (resolve, reject) {
      if (_this.isWifiEnabled) {
        resolve();
      } else {
        var interval = null;
        var timeout = setTimeout(function () {
          clearInterval(interval);
          reject(new Error('wait for wifi timeout.'));
        }, timeoutMilliseconds);
        interval = setInterval(function () {
          if (_this.isWifiEnabled) {
            clearTimeout(timeout);
            resolve();
          }
        }, 1000);
      }
    });
  },
  getConnectedSSID: function () {
    var _getConnectedSSID = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6() {
      var ssid;
      return regenerator.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              log$3("getConnectedSSID");
              _context6.prev = 1;
              _context6.next = 4;
              return wifiFacad.getConnectedSSID();

            case 4:
              ssid = _context6.sent;
              log$3("getConnectedSSID() success");
              return _context6.abrupt("return", ssid);

            case 9:
              _context6.prev = 9;
              _context6.t0 = _context6["catch"](1);
              log$3('releaseWifiConnectionOn error', _context6.t0);

            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[1, 9]]);
    }));

    function getConnectedSSID() {
      return _getConnectedSSID.apply(this, arguments);
    }

    return getConnectedSSID;
  }(),
  install: function install(Vue, opts, $xp, cfg) {
    if ($xp.wifiInstalled) {
      return;
    }

    $xp.wifiInstalled = true;
    Vue.util.defineReactive($xp, 'wifi', this);
  }
};

var getSettings = function getSettings() {
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_IS_LOAN_DEVICE) {
      window.XpedeoPreloader.getSettings(function (settings) {
        resolve(settings);
      }, function (errMsg) {
        reject(new Error(errMsg));
      });
    } else {
      var remoteUrl = window.XPEDEO_SETTINGS.content.remoteUrl;
      var useStaticPageFiles = typeof window.XPEDEO_SETTINGS.content.useStaticPageFiles !== 'undefined' && window.XPEDEO_SETTINGS.content.useStaticPageFiles;
      var url = remoteUrl + 'xpedeo/' + (useStaticPageFiles ? 'P37.json' : 'api/v1/pages/37');
      axios.get(url).then(function (response) {
        resolve(response.data.Settings);
      }).catch(function (e) {
        return reject(e);
      });
    }
  });
};

var setSettings = function setSettings(jsonString) {
  return new Promise(function (resolve, reject) {
    if (window.device.platform.toLowerCase() === 'android') {
      window.XpedeoPreloader.setSettings(jsonString, function () {
        resolve(JSON.parse(jsonString));
      }, function (errMsg) {
        reject(new Error(errMsg));
      });
    } else {
      resolve(JSON.parse(jsonString));
    }
  });
};

var settingsFacade = {
  getSettings: getSettings,
  setSettings: setSettings
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;
var isArray_1 = isArray;

/** Detect free variable `global` from Node.js. */

var freeGlobal = _typeof(commonjsGlobal) == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */

var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root = _freeGlobal || freeSelf || Function('return this')();
var _root = root;

/** Built-in value references. */

var _Symbol2 = _root.Symbol;
var _Symbol = _Symbol2;

/** Used for built-in method references. */

var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString = objectProto.toString;
/** Built-in value references. */

var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */

function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);

  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }

  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString$1 = objectProto$1.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */

function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */

var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';
/** Built-in value references. */

var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }

  return symToStringTag$1 && symToStringTag$1 in Object(value) ? _getRawTag(value) : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && _typeof(value) == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */

var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */

function isSymbol(value) {
  return _typeof(value) == 'symbol' || isObjectLike_1(value) && _baseGetTag(value) == symbolTag;
}

var isSymbol_1 = isSymbol;

/** Used to match property names within property paths. */

var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */

function isKey(value, object) {
  if (isArray_1(value)) {
    return false;
  }

  var type = _typeof(value);

  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol_1(value)) {
    return true;
  }

  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}

var _isKey = isKey;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = _typeof(value);

  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject;

/** `Object#toString` result references. */

var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */

function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  } // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.


  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction;

/** Used to detect overreaching core-js shims. */

var coreJsData = _root['__core-js_shared__'];
var _coreJsData = coreJsData;

/** Used to detect methods masquerading as native. */

var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */


function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

var _isMasked = isMasked;

/** Used for built-in method references. */
var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */

function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}

    try {
      return func + '';
    } catch (e) {}
  }

  return '';
}

var _toSource = toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */

var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */

var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */

var funcProto$1 = Function.prototype,
    objectProto$2 = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString$1 = funcProto$1.toString;
/** Used to check objects for own properties. */

var hasOwnProperty$1 = objectProto$2.hasOwnProperty;
/** Used to detect if a method is native. */

var reIsNative = RegExp('^' + funcToString$1.call(hasOwnProperty$1).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */

function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }

  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */

function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;

/* Built-in method references that are verified to be native. */

var nativeCreate = _getNative(Object, 'create');
var _nativeCreate = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */

function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

var _hashClear = hashClear;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete;

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */

var objectProto$3 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$2 = objectProto$3.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function hashGet(key) {
  var data = this.__data__;

  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }

  return hasOwnProperty$2.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet;

/** Used for built-in method references. */

var objectProto$4 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$3 = objectProto$4.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? data[key] !== undefined : hasOwnProperty$3.call(data, key);
}

var _hashHas = hashHas;

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */

function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = _nativeCreate && value === undefined ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `Hash`.


Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;
var _Hash = Hash;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

var eq_1 = eq;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function assocIndexOf(array, key) {
  var length = array.length;

  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }

  return -1;
}

var _assocIndexOf = assocIndexOf;

/** Used for built-in method references. */

var arrayProto = Array.prototype;
/** Built-in value references. */

var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }

  var lastIndex = data.length - 1;

  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }

  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */

function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }

  return this;
}

var _listCacheSet = listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `ListCache`.


ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;
var _ListCache = ListCache;

/* Built-in method references that are verified to be native. */

var Map$1 = _getNative(_root, 'Map');
var _Map = Map$1;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */

function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash(),
    'map': new (_Map || _ListCache)(),
    'string': new _Hash()
  };
}

var _mapCacheClear = mapCacheClear;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = _typeof(value);

  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

var _isKeyable = isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */

function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

var _getMapData = getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

var _mapCacheGet = mapCacheGet;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

var _mapCacheHas = mapCacheHas;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */

function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `MapCache`.


MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;
var _MapCache = MapCache;

/** Error message constants. */

var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */

function memoize(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }

  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }

    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };

  memoized.cache = new (memoize.Cache || _MapCache)();
  return memoized;
} // Expose `MapCache`.


memoize.Cache = _MapCache;
var memoize_1 = memoize;

/** Used as the maximum memoize cache size. */

var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */

function memoizeCapped(func) {
  var result = memoize_1(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }

    return key;
  });
  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped;

/** Used to match property names within property paths. */

var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */

var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */

var stringToPath = _memoizeCapped(function (string) {
  var result = [];

  if (string.charCodeAt(0) === 46
  /* . */
  ) {
      result.push('');
    }

  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});
var _stringToPath = stringToPath;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }

  return result;
}

var _arrayMap = arrayMap;

/** Used as references for various `Number` constants. */

var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */

var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */

function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }

  if (isArray_1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }

  if (isSymbol_1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

var _baseToString = baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */

function toString(value) {
  return value == null ? '' : _baseToString(value);
}

var toString_1 = toString;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */

function castPath(value, object) {
  if (isArray_1(value)) {
    return value;
  }

  return _isKey(value, object) ? [value] : _stringToPath(toString_1(value));
}

var _castPath = castPath;

/** Used as references for various `Number` constants. */

var INFINITY$1 = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */

function toKey(value) {
  if (typeof value == 'string' || isSymbol_1(value)) {
    return value;
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$1 ? '-0' : result;
}

var _toKey = toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */

function baseGet(object, path) {
  path = _castPath(path, object);
  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[_toKey(path[index++])];
  }

  return index && index == length ? object : undefined;
}

var _baseGet = baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */

function get(object, path, defaultValue) {
  var result = object == null ? undefined : _baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get;

var defaultSettings = {
  content: {
    startPageId: null,
    remoteUrl: '',
    useStaticPageFiles: false,
    welcomeScreenId: null,
    nfcPageId: null
  },
  radio: {
    wifi: {
      APs: null
      /* Example:
      [
      {
      SSID: 'xpedeo',
      authType: 'WPA',
      password: 'abcDEF123',
      hidden: false
      }
      ]
      */

    },
    nfcActive: false
  },
  screen: {
    brightness: 200,
    standbySeconds: 120,
    halfDimMilliseconds: 120 * 1000,
    fullDimMilliseconds: 180 * 1000,
    halfDimValue: 100,
    fullDimValue: 0
  },
  battery: {
    warningIntervalSeconds: 600,
    dockSleepLevel: 95,
    isPlugged: false
  },
  navigation: {
    backOnAudioEnd: true,
    backOnVideoEnd: true,
    nextPageOnMediaEnd: true,
    resolveBeaconWhilePlaying: false,
    autoPlayPageAudio: true,
    playBeepOnResolvedBeacon: true,
    vibrateOnResolvedBeacon: true,
    numpadInputExtraButtons: [],
    showWelcomeScreen: false,
    autoHideNavDuration: 2000,
    showChildPagesMenu: true
  },
  theme: 't-dark',
  showDeviceName: false,
  exitAppNow: null,
  evaluationEnabled: null,
  allowHardwareVolumeControl: false,
  showLocationSettingsWarning: false,
  showSubtitlesDefault: false,
  zoomRatio: null,
  maxLipsyncLatency: {
    audio: 40,
    video: 1500
  },
  isPanoramaDeviceOrientationEnabled: true
};

var log$4 = debug('xpedeo-core:settings');
debug.enable(process.env.VUE_APP_DEBUG);
var Settings = {
  __loadedSettings: defaultSettings,
  __pageSettingsArray: [],
  __mergedSettings: {},
  __$xp: null,

  get pageSettingsArray() {
    return this.__pageSettingsArray;
  },

  set pageSettingsArray(value) {
    var mergedPageSettings = value.length >= 2 ? deepmerge.all(Object.values(value)) : value.length === 1 ? value[0] : {};
    this.__mergedSettings = deepmerge(Object.assign({}, this.__loadedSettings), mergedPageSettings);
    this.__pageSettingsArray = value;
  },

  get mergedSettings() {
    return this.__mergedSettings;
  },

  get remoteUrl() {
    return get_1(this.mergedSettings, 'content.remoteUrl') ? get_1(this.mergedSettings, 'content.remoteUrl') : '';
  },

  get baseUrl() {
    if (this.remoteUrl === '') {
      return window.XPEDEO_SETTINGS.content.remoteUrl;
    } else {
      return this.mergedSettings.content.remoteUrl;
    }
  },

  get useStaticPageFiles() {
    if (window.XPEDEO_SETTINGS && window.XPEDEO_SETTINGS.content && typeof window.XPEDEO_SETTINGS.content.useStaticPageFiles !== 'undefined') {
      return window.XPEDEO_SETTINGS.content.useStaticPageFiles;
    } else {
      return this.mergedSettings.content.useStaticPageFiles;
    }
  },

  getValue: function getValue(valuePath) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    return get_1(this.mergedSettings, valuePath, defaultValue);
  },
  resetSettingsState: function resetSettingsState() {
    this.pageSettingsArray = [];
  },
  initSettings: function () {
    var _initSettings = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      var settings;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              log$4("initSettings");
              _context.next = 3;
              return settingsFacade.getSettings();

            case 3:
              settings = _context.sent;

              if (!this.__$xp.device.isLoan && window.XPEDEO_SETTINGS) {
                settings = deepmerge(settings, window.XPEDEO_SETTINGS);
              }

              this.__loadedSettings = deepmerge(this.__loadedSettings, settings);
              this.pageSettingsArray = [];
              log$4("settings initialized successfully.", this.__loadedSettings);

              if (!this.__$xp.device.isLoan || settings.allowHardwareVolumeControl) {
                this.__$xp.media.setGlobalVolume(1);

                this.__$xp.media.setAllowUIVolumeControl(false);
              }

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function initSettings() {
      return _initSettings.apply(this, arguments);
    }

    return initSettings;
  }(),
  addPageSettings: function addPageSettings(pageId, pageSettings) {
    var _this = this;

    // @TODO xpedeo-core there could be a performance enhancement here.
    // could the array be mutated?
    log$4('addPageSettings', {
      pageId: pageId,
      pageSettings: pageSettings
    });
    var newPageSettingsArray = [];

    this.__$xp.history.historyArray.forEach(function (item, index) {
      if (item.pageId === pageId) {
        newPageSettingsArray[index] = pageSettings;
      } else {
        if (_this.pageSettingsArray[index]) {
          newPageSettingsArray[index] = _this.pageSettingsArray[index];
        }
      }
    });

    this.pageSettingsArray = newPageSettingsArray;
    log$4('addPageSettings success', this.pageSettingsArray);
  },
  install: function install(Vue, opts, $xp, cfg) {
    if ($xp.settingsInstalled) {
      return;
    }

    this.__$xp = $xp;
    $xp.settingsInstalled = true;
    this.__mergedSettings = Object.assign({}, defaultSettings);
    Vue.util.defineReactive($xp, 'settings', this);
  }
};

var preventSleep = function preventSleep() {
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_IS_LOAN_DEVICE) {
      window.XpedeoPreloader.preventSleep(function () {
        resolve();
      }, function (errMsg) {
        reject(new Error(errMsg));
      });
    } else resolve();
  });
};

var allowSleep = function allowSleep() {
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_IS_LOAN_DEVICE) {
      window.XpedeoPreloader.allowSleep(function () {
        resolve();
      }, function (errMsg) {
        reject(new Error(errMsg));
      });
    } else resolve();
  });
};

var setBrightness = function setBrightness(brightness) {
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_IS_LOAN_DEVICE) {
      window.XpedeoPreloader.setScreenBrightness(brightness ? [brightness] : [], function () {
        resolve();
      }, function (errMsg) {
        reject(new Error(errMsg));
      });
    } else resolve(brightness);
  });
};

var setOrientation = function setOrientation(orientation) {
  return new Promise(function (resolve, reject) {
    if (process.env.VUE_APP_IS_LOAN_DEVICE) {
      window.XpedeoPreloader.setScreenOrientation(orientation ? [orientation] : [], function () {
        resolve();
      }, function (errMsg) {
        reject(new Error(errMsg));
      });
    } else if (['ios', 'android'].includes(process.env.VUE_APP_PLATFORM)) {
      orientation ? window.screen.orientation.lock(orientation) : window.screen.orientation.unlock();
      resolve();
    }
  });
};

var getOrientation = function getOrientation() {
  return window.screen.orientation;
};

var screenFacade = {
  preventSleep: preventSleep,
  allowSleep: allowSleep,
  setBrightness: setBrightness,
  setOrientation: setOrientation,
  getOrientation: getOrientation
};

var listenOpts = {
  hasPassive: false,
  passiveCapture: true,
  notPassiveCapture: true
}; // feature detection for event listener options

try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      Object.assign(listenOpts, {
        hasPassive: true,
        passive: {
          passive: true
        },
        notPassive: {
          passive: false
        },
        passiveCapture: {
          passive: true,
          capture: true
        },
        notPassiveCapture: {
          passive: false,
          capture: true
        }
      });
    }
  });
  window.addEventListener('xptest', null, opts);
  window.removeEventListener('xptest', null, opts);
} catch (e) {}
function position(e) {
  if (e.touches && e.touches[0]) {
    e = e.touches[0];
  } else if (e.changedTouches && e.changedTouches[0]) {
    e = e.changedTouches[0];
  } else if (e.targetTouches && e.targetTouches[0]) {
    e = e.targetTouches[0];
  }

  return {
    top: e.clientY,
    left: e.clientX
  };
}

/**
 * Debouncing enforces that a function not be called again until a certain amount of time has passed without it being called.
 * see http://demo.nimius.net/debounce_throttle/
 *
 * @param {function} fn function to debounce
 * @param {integer} wait in milliseconds
 * @param {boolean} immediate whether to execute immediately
 */
function debounce (fn) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var immediate = arguments.length > 2 ? arguments[2] : undefined;
  var timeout;

  function debounced()
  /* ...args */
  {
    var _this = this;

    var args = arguments;

    var later = function later() {
      timeout = null;

      if (!immediate) {
        fn.apply(_this, args);
      }
    };

    clearTimeout(timeout);

    if (immediate && !timeout) {
      fn.apply(this, args);
    }

    timeout = setTimeout(later, wait);
  }

  debounced.cancel = function () {
    clearTimeout(timeout);
  };

  return debounced;
}

var passive = listenOpts.passive;
var log$5 = debug('xpedeo-core:screen');
debug.enable(process.env.VUE_APP_DEBUG);
var prefixes = {}; // needed for consistency across browsers,
// including IE11 which does not return anything

function promisify(target, fn) {
  try {
    var res = target[fn]();
    return res === void 0 ? Promise.resolve() : res;
  } catch (err) {
    return Promise.reject(err);
  }
}

var dimTimeout = 0;
/**
 * This plugin require cordova-plugin-screen-orientation
 */

var Screen = {
  __brightness: null,
  __isDimPrevented: false,
  __isHalfDim: false,
  __isFullDim: false,
  __isIdle: false,
  __isFullscreenActive: false,
  __canFullscreen: false,
  __orientation: null,
  __isBrowserNavBarVisible: false,
  __$xp: null,
  __width: 0,
  __height: 0,

  get isFullscreenActive() {
    return this.__isFullscreenActive;
  },

  get orientation() {
    return this.__orientation;
  },

  get isBrowserNavBarVisible() {
    return this.__isBrowserNavBarVisible;
  },

  get defaultBrightness() {
    return this.__$xp.settings.getValue('screen.brightness');
  },

  get halfDimMilliseconds() {
    return this.__$xp.settings.getValue('screen.halfDimMilliseconds');
  },

  get fullDimMilliseconds() {
    return this.__$xp.settings.getValue('screen.fullDimMilliseconds');
  },

  get halfDimValue() {
    return this.__$xp.settings.getValue('screen.halfDimValue');
  },

  get fullDimValue() {
    return this.__$xp.settings.getValue('screen.fullDimValue');
  },

  get isIdle() {
    return this.__isIdle;
  },

  get width() {
    return this.__width;
  },

  get height() {
    return this.__height;
  },

  setBrightness: function () {
    var _setBrightness = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(brightness) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              log$5("setBrightness(".concat(brightness, ")"));
              _context.prev = 1;
              _context.next = 4;
              return screenFacade.setBrightness(Number.isInteger(brightness) ? brightness : this.defaultBrightness);

            case 4:
              this.__brightness = _context.sent;
              log$5("setBrightness success");
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              log$5("setBrightness error", _context.t0);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[1, 8]]);
    }));

    function setBrightness(_x) {
      return _setBrightness.apply(this, arguments);
    }

    return setBrightness;
  }(),
  preventDim: function preventDim() {
    log$5('preventDim()');
    clearTimeout(dimTimeout);
    this.__isDimPrevented = true;
  },
  allowDim: function () {
    var _allowDim = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              log$5("allowDim()");
              this.__isDimPrevented = false;
              _context2.next = 4;
              return this.postponeDim();

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function allowDim() {
      return _allowDim.apply(this, arguments);
    }

    return allowDim;
  }(),
  postponeDim: function () {
    var _postponeDim = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
      var _this = this;

      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              log$5("postponeDim()");
              clearTimeout(dimTimeout);
              _context3.next = 4;
              return this.setBrightness();

            case 4:
              this.__isHalfDim = false;
              this.__isFullDim = false;
              this.__isIdle = false;

              if (!this.__isDimPrevented) {
                dimTimeout = setTimeout(function () {
                  _this.setBrightness(_this.halfDimValue);

                  _this.__isHalfDim = true;
                  _this.__isIdle = true;
                  clearTimeout(dimTimeout);
                  dimTimeout = setTimeout(function () {
                    _this.setBrightness(_this.fullDimValue);

                    _this.__isHalfDim = false;
                    _this.__isFullDim = true;
                  }, _this.fullDimMilliseconds - _this.halfDimMilliseconds);
                }, this.halfDimMilliseconds);
              }

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function postponeDim() {
      return _postponeDim.apply(this, arguments);
    }

    return postponeDim;
  }(),
  cancelDimTimer: function cancelDimTimer() {
    log$5("cancelDimTimer()");
    clearTimeout(dimTimeout);
  },
  preventSleep: function preventSleep() {
    log$5("preventSleep()");
    screenFacade.preventSleep();
  },
  allowSleep: function allowSleep() {
    log$5("allowSleep()");
    screenFacade.allowSleep();
  },
  setOrientation: function setOrientation(orientation) {
    log$5("setOrientation()");
    screenFacade.setOrientation(orientation);

    this.__$xp.navigation.showNav(true);
  },
  requestFullscreen: function requestFullscreen(target, evenOnNonMobile) {
    return (evenOnNonMobile || this.__$xp.device.isTouchDevice) && this.__canFullscreen && !this.__isFullscreenActive ? promisify(target || document.documentElement, prefixes.request) : this.__getErr();
  },
  exitFullscreen: function exitFullscreen() {
    return this.__canFullscreen && this.__isFullscreenActive ? promisify(document, prefixes.exit) : this.__getErr();
  },
  toggleFullscreen: function toggleFullscreen(target, evenOnNonMobile) {
    return this.isFullscreenActive ? this.exitFullscreen() : this.requestFullscreen(target, evenOnNonMobile);
  },
  initFullscreen: function initFullscreen() {
    var _this2 = this;

    this.__getErr = function () {
      return Promise.resolve();
    };

    prefixes.request = ['requestFullscreen', 'msRequestFullscreen', 'mozRequestFullScreen', 'webkitRequestFullscreen'].find(function (request) {
      return document.documentElement[request];
    });
    this.__canFullscreen = prefixes.request !== void 0;

    if (this.__canFullscreen === false) {
      // it means the browser does NOT support it
      this.__getErr = function () {
        return Promise.reject(new Error('Not capable to request fullscreen'));
      };

      return;
    }

    this.__getErr = function () {
      return Promise.resolve();
    };

    prefixes.exit = ['exitFullscreen', 'msExitFullscreen', 'mozCancelFullScreen', 'webkitExitFullscreen'].find(function (exit) {
      return document[exit];
    });
    this.__isFullscreenActive = !!(document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement);
    ['onfullscreenchange', 'onmsfullscreenchange', 'onwebkitfullscreenchange'].forEach(function (event) {
      document[event] = function () {
        _this2.__isFullscreenActive = !_this2.__isFullscreenActive;
      };
    });
  },
  initOrientation: function initOrientation() {
    var _this3 = this;

    if (this.__$xp.device.platform === 'ios' || this.__$xp.device.platform === 'browser' && this.__$xp.device.isIPhoneOrPad) {
      this.__orientation = this.getIosOrientation();
    } else if (window.screen.orientation) {
      this.__orientation = window.screen.orientation ? window.screen.orientation.type : 'undefined';
    }

    window.addEventListener('orientationchange', function () {
      if (_this3.__$xp.device.platform === 'ios' || _this3.__$xp.device.platform === 'browser' && _this3.__$xp.device.isIPhoneOrPad) {
        _this3.__orientation = _this3.getIosOrientation();
        var event = new Event('resize');
        var target = window.visualViewport !== void 0 ? window.visualViewport : window;
        target.dispatchEvent(event);
      } else {
        _this3.__orientation = screen.orientation ? screen.orientation.type : 'undefined';
      }

      _this3.__$xp.navigation.showNav(true);
    }, true);
  },
  getIosOrientation: function getIosOrientation() {
    if (window.orientation !== undefined) {
      switch (window.orientation) {
        case 0:
          return 'portrait-primary';

        case 180:
          return 'portrait-secondary';

        case -90:
          return 'landscape-primary';

        case 90:
          return 'landscape-secondary';
      }
    } else return 'undefined';
  },
  initResizeHandler: function initResizeHandler() {
    var _this4 = this;

    var target = window.visualViewport !== void 0 ? window.visualViewport : window;

    var update = function update() {
      log$5("window resize update handler");

      if (window.innerHeight !== _this4.__height) {
        _this4.__height = window.innerHeight;
      }

      if (window.innerWidth !== _this4.__width) {
        _this4.__width = window.innerWidth;
      }

      var outerHeight = window.outerHeight;
      var windowHeight = window.innerHeight;
      log$5('outerHeight', outerHeight, windowHeight, _this4.__orientation);

      if (_this4.__orientation && _this4.__orientation.includes('portrait')) {
        _this4.__isBrowserNavBarVisible = false;
        return;
      }

      _this4.__isBrowserNavBarVisible = windowHeight < outerHeight;

      if (_this4.__isBrowserNavBarVisible) {
        _this4.__$xp.navigation.showNav();
      }

      log$5('BrowserNavBar is ' + (_this4.__isBrowserNavBarVisible ? 'visible' : 'NOT visible'));
    };

    var updateHandler = debounce(update, 500);
    target.addEventListener('resize', updateHandler, passive);
  },
  install: function install(Vue, opts, $xp, cfg) {
    if ($xp.screenInstalled) {
      return;
    }

    $xp.screenInstalled = true;
    this.__$xp = $xp;
    this.initFullscreen();
    this.initOrientation();
    this.initResizeHandler();
    Vue.util.defineReactive($xp, 'screen', this);
  }
};

var log$6 = debug('xpedeo-core:network');
debug.enable(process.env.VUE_APP_DEBUG);
var Network = {
  __isOnline: true,
  __onlineObservers: [],
  __offlineObservers: [],

  get isOnline() {
    return this.__isOnline;
  },

  subscribe: function subscribe(eventType, cb) {
    log$6("subscribe(".concat(eventType, ", ").concat(cb, ")"));

    if (eventType === 'online') {
      this.__onlineObservers.push(cb);
    } else if (eventType === 'offline') {
      this.__offlineObservers.push(cb);
    } else {
      throw new Error("xpedeo-core:network unknown event type ".concat(eventType));
    }
  },
  unsubscribe: function unsubscribe(eventType, cb) {
    log$6("unsubscribe(".concat(eventType, ", ").concat(cb, ")"));

    if (eventType === 'online') {
      this.__onlineObservers = this.__onlineObservers.filter(function (subscriber) {
        return subscriber !== cb;
      });
    } else if (eventType === 'offline') {
      this.__offlineObservers = this.__offlineObservers.filter(function (subscriber) {
        return subscriber !== cb;
      });
    } else {
      throw new Error("xpedeo-core:network unknown event type ".concat(eventType));
    }
  },
  notify: function notify(eventType) {
    log$6("notify(".concat(eventType, ")"));

    if (eventType === 'online') {
      this.__onlineObservers.forEach(function (observer) {
        return observer();
      });
    } else if (eventType === 'offline') {
      this.__offlineObservers.forEach(function (observer) {
        return observer();
      });
    } else {
      throw new Error("xpedeo-core:network unknown event type ".concat(eventType));
    }
  },
  startListening: function startListening() {
    log$6("startListening()");
    this.__isOnline = navigator.onLine;
    document.addEventListener('offline', this.onOffline.bind(this), false);
    document.addEventListener('online', this.onOnline.bind(this), false);
  },
  stopListening: function stopListening() {
    log$6("stopListening()");
    document.removeEventListener('offline', this.onOffline, false);
    document.removeEventListener('online', this.onOnline, false);
  },
  onOffline: function onOffline() {
    log$6("onOffline()");
    this.__isOnline = false;
    this.notify('offline');
  },
  onOnline: function onOnline() {
    log$6("onOnline()", this);
    this.__isOnline = true;
    this.notify('online');
  },
  waitForOnline: function waitForOnline() {
    var _this = this;

    var timeoutMilliseconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10000;
    log$6("waitForOnline(".concat(timeoutMilliseconds, ")"));
    return new Promise(function (resolve, reject) {
      if (_this.__isOnline) {
        resolve();
      } else {
        var interval = null;
        var timeout = setTimeout(function () {
          clearInterval(interval);
          reject(new Error('wait for online timeout.'));
        }, timeoutMilliseconds);
        interval = setInterval(function () {
          if (_this.__isOnline) {
            clearTimeout(timeout);
            resolve();
          }
        }, 500);
      }
    });
  },
  recheckIsOnline: function recheckIsOnline() {
    log$6("recheckIsOnline()");

    if (navigator.onLine) {
      this.onOnline();
    } else {
      this.onOffline();
    }

    return this.__isOnline;
  },
  install: function install(Vue, opts, $xp, cfg) {
    if ($xp.networkInstalled) {
      return;
    }

    $xp.networkInstalled = true;
    Vue.util.defineReactive($xp, 'network', this);
  }
};

var log$7 = debug('xpedeo-core:media');
debug.enable(process.env.VUE_APP_DEBUG);
var Media = {
  __volume: 0.5,
  __allowUIVolumeControl: true,
  __isMediaPlaying: false,
  __showSubtitles: false,
  __isImageZoomDialogActive: false,

  get volume() {
    return this.__volume;
  },

  get allowUIVolumeControl() {
    return this.__allowUIVolumeControl;
  },

  get isMediaPlaying() {
    return this.__isMediaPlaying;
  },

  get showSubtitles() {
    return this.__showSubtitles;
  },

  get isImageZoomDialogActive() {
    return this.__isImageZoomDialogActive;
  },

  setGlobalVolume: function setGlobalVolume(value) {
    log$7("setGlobalVolume(".concat(value, ")"));
    this.__volume = value;
  },
  setIsMediaPlaying: function setIsMediaPlaying(value) {
    log$7("setIsMediaPlaying(".concat(value, ")"));
    this.__isMediaPlaying = value;
  },
  setAllowUIVolumeControl: function setAllowUIVolumeControl(value) {
    log$7("setAllowUIVolumeControl(".concat(value, ")"));
    this.__allowUIVolumeControl = value;
  },
  setShowSubtitles: function setShowSubtitles(value) {
    log$7("setShowSubtitles(".concat(value, ")"));
    this.__showSubtitles = value;
  },
  setIsImageZoomDialogActive: function setIsImageZoomDialogActive(value) {
    log$7("setIsImageZoomDialogActive(".concat(value, ")"));
    this.__isImageZoomDialogActive = value;
  },
  install: function install(Vue, opts, $xp, cfg) {
    if ($xp.mediaInstalled) {
      return;
    }

    $xp.mediaInstalled = true;
    Vue.util.defineReactive($xp, 'media', this);
  }
};

var log$8 = debug('xpedeo-core:content');
debug.enable(process.env.VUE_APP_DEBUG);
var Content = {
  __$xp: null,
  __pageData: {},
  __glRenderer: null,

  get pageData() {
    return this.__pageData;
  },

  get pageTitle() {
    return this.__pageData.Title;
  },

  get glRenderer() {
    return this.__glRenderer;
  },

  set glRenderer(renderer) {
    this.__glRenderer = renderer;
  },

  get blockedBeaconsPageIds() {
    return this.__pageData.BlockedBeaconPageIDs;
  },

  get allowedBeaconsPageIds() {
    return this.__pageData.AllowedBeaconPageIDs;
  },

  setPageData: function setPageData(value) {
    this.__pageData = value;
  },
  install: function install(Vue, opts, $xp, cfg) {
    if ($xp.contentInstalled) {
      return;
    }

    this.__$xp = $xp;
    $xp.contentInstalled = true;
    Vue.util.defineReactive($xp, 'content', this);
  },

  /**
   * Liefert die benötigte Breite eines Vollbild-Bildes abhängig von den verfügbaren Größen auf dem Server
   * @param binaryJson Json-Datenstruktur des Binaries
   * @returns {number}
   */
  getRequiredImageWidth: function getRequiredImageWidth(binaryJson) {
    log$8('getRequiredImageWidth');
    var width = (window.innerWidth || document.documentElement.clientWidth) * window.devicePixelRatio;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = this.__$xp.settings.mergedSettings.content.imageResolutions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var w = _step.value;

        if (w >= width) {
          width = w;
          break;
        }
      } // console.log('getRequiredImageWidth() binaryJson:', binaryJson, ' ==', Math.min(binaryJson.Width, width))

    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return Math.min(binaryJson.Width, width);
  },

  /**
   * Liefert die URL zum Laden eines Bildes
   * @param binaryJson Json-Datenstruktur des Binaries
   * @param requiredImageWidth Gewünschte Breite; 0: Maximalgröße; null: anhand der Bildschirmbreite berechnen
   * @returns {string} URL des Bildes
   */
  getImageUrl: function getImageUrl(binaryJson, requiredImageWidth) {
    var url = this.__$xp.settings.baseUrl + 'xpedeo/' + binaryJson.Url;

    if (!this.__$xp.device.platform.isLoan) {
      if (typeof requiredImageWidth === 'undefined') {
        requiredImageWidth = this.getRequiredImageWidth(binaryJson);
      }

      if (requiredImageWidth !== 0 && requiredImageWidth !== binaryJson.Width) {
        url = url.replace(/(\.[a-z]{3,4})$/, '.' + requiredImageWidth + '$1');
      }
    }

    return url;
  }
};

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}

var timeout = createCommonjsModule(function (module, exports) {
  (function (exports) {
    var MAX_INT = 2147483647;
    var timeouts = {};
    var index = 1; // Set new timeout

    var set = function set(callback, timeout) {
      var id = index++;

      if (timeout > MAX_INT) {
        timeouts[id] = setTimeout(set.bind(undefined, callback, timeout - MAX_INT), MAX_INT);
      } else {
        if (timeout < 0) timeout = 0;
        timeouts[id] = setTimeout(function () {
          delete timeouts[id];
          callback();
        }, timeout);
      }

      return id;
    }; // Clear existing timeout


    var clear = function clear(id) {
      if (timeouts.hasOwnProperty(id)) {
        clearTimeout(timeouts[id]);
        delete timeouts[id];
      }
    }; // Expose public interface


    exports.set = set;
    exports.clear = clear;
    exports._timeouts = timeouts;
  })( exports);
});

var infiniteTimeout = timeout;

var backboneEventsStandalone = createCommonjsModule(function (module, exports) {
  /**
   * Standalone extraction of Backbone.Events, no external dependency required.
   * Degrades nicely when Backone/underscore are already available in the current
   * global context.
   *
   * Note that docs suggest to use underscore's `_.extend()` method to add Events
   * support to some given object. A `mixin()` method has been added to the Events
   * prototype to avoid using underscore for that sole purpose:
   *
   *     var myEventEmitter = BackboneEvents.mixin({});
   *
   * Or for a function constructor:
   *
   *     function MyConstructor(){}
   *     MyConstructor.prototype.foo = function(){}
   *     BackboneEvents.mixin(MyConstructor.prototype);
   *
   * (c) 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
   * (c) 2013 Nicolas Perriault
   */

  /* global exports:true, define, module */
  (function () {
    var nativeForEach = Array.prototype.forEach,
        hasOwnProperty = Object.prototype.hasOwnProperty,
        slice = Array.prototype.slice,
        idCounter = 0; // Returns a partial implementation matching the minimal API subset required
    // by Backbone.Events

    function miniscore() {
      return {
        keys: Object.keys || function (obj) {
          if (_typeof(obj) !== "object" && typeof obj !== "function" || obj === null) {
            throw new TypeError("keys() called on a non-object");
          }

          var key,
              keys = [];

          for (key in obj) {
            if (obj.hasOwnProperty(key)) {
              keys[keys.length] = key;
            }
          }

          return keys;
        },
        uniqueId: function uniqueId(prefix) {
          var id = ++idCounter + '';
          return prefix ? prefix + id : id;
        },
        has: function has(obj, key) {
          return hasOwnProperty.call(obj, key);
        },
        each: function each(obj, iterator, context) {
          if (obj == null) return;

          if (nativeForEach && obj.forEach === nativeForEach) {
            obj.forEach(iterator, context);
          } else if (obj.length === +obj.length) {
            for (var i = 0, l = obj.length; i < l; i++) {
              iterator.call(context, obj[i], i, obj);
            }
          } else {
            for (var key in obj) {
              if (this.has(obj, key)) {
                iterator.call(context, obj[key], key, obj);
              }
            }
          }
        },
        once: function once(func) {
          var ran = false,
              memo;
          return function () {
            if (ran) return memo;
            ran = true;
            memo = func.apply(this, arguments);
            func = null;
            return memo;
          };
        }
      };
    }

    var _ = miniscore(),
        Events; // Backbone.Events
    // ---------------
    // A module that can be mixed in to *any object* in order to provide it with
    // custom events. You may bind with `on` or remove with `off` callback
    // functions to an event; `trigger`-ing an event fires all callbacks in
    // succession.
    //
    //     var object = {};
    //     _.extend(object, Backbone.Events);
    //     object.on('expand', function(){ alert('expanded'); });
    //     object.trigger('expand');
    //


    Events = {
      // Bind an event to a `callback` function. Passing `"all"` will bind
      // the callback to all events fired.
      on: function on(name, callback, context) {
        if (!eventsApi(this, 'on', name, [callback, context]) || !callback) return this;
        this._events || (this._events = {});
        var events = this._events[name] || (this._events[name] = []);
        events.push({
          callback: callback,
          context: context,
          ctx: context || this
        });
        return this;
      },
      // Bind an event to only be triggered a single time. After the first time
      // the callback is invoked, it will be removed.
      once: function once(name, callback, context) {
        if (!eventsApi(this, 'once', name, [callback, context]) || !callback) return this;
        var self = this;

        var once = _.once(function () {
          self.off(name, once);
          callback.apply(this, arguments);
        });

        once._callback = callback;
        return this.on(name, once, context);
      },
      // Remove one or many callbacks. If `context` is null, removes all
      // callbacks with that function. If `callback` is null, removes all
      // callbacks for the event. If `name` is null, removes all bound
      // callbacks for all events.
      off: function off(name, callback, context) {
        var retain, ev, events, names, i, l, j, k;
        if (!this._events || !eventsApi(this, 'off', name, [callback, context])) return this;

        if (!name && !callback && !context) {
          this._events = {};
          return this;
        }

        names = name ? [name] : _.keys(this._events);

        for (i = 0, l = names.length; i < l; i++) {
          name = names[i];

          if (events = this._events[name]) {
            this._events[name] = retain = [];

            if (callback || context) {
              for (j = 0, k = events.length; j < k; j++) {
                ev = events[j];

                if (callback && callback !== ev.callback && callback !== ev.callback._callback || context && context !== ev.context) {
                  retain.push(ev);
                }
              }
            }

            if (!retain.length) delete this._events[name];
          }
        }

        return this;
      },
      // Trigger one or many events, firing all bound callbacks. Callbacks are
      // passed the same arguments as `trigger` is, apart from the event name
      // (unless you're listening on `"all"`, which will cause your callback to
      // receive the true name of the event as the first argument).
      trigger: function trigger(name) {
        if (!this._events) return this;
        var args = slice.call(arguments, 1);
        if (!eventsApi(this, 'trigger', name, args)) return this;
        var events = this._events[name];
        var allEvents = this._events.all;
        if (events) triggerEvents(events, args);
        if (allEvents) triggerEvents(allEvents, arguments);
        return this;
      },
      // Tell this object to stop listening to either specific events ... or
      // to every object it's currently listening to.
      stopListening: function stopListening(obj, name, callback) {
        var listeners = this._listeners;
        if (!listeners) return this;
        var deleteListener = !name && !callback;
        if (_typeof(name) === 'object') callback = this;
        if (obj) (listeners = {})[obj._listenerId] = obj;

        for (var id in listeners) {
          listeners[id].off(name, callback, this);
          if (deleteListener) delete this._listeners[id];
        }

        return this;
      }
    }; // Regular expression used to split event strings.

    var eventSplitter = /\s+/; // Implement fancy features of the Events API such as multiple event
    // names `"change blur"` and jQuery-style event maps `{change: action}`
    // in terms of the existing API.

    var eventsApi = function eventsApi(obj, action, name, rest) {
      if (!name) return true; // Handle event maps.

      if (_typeof(name) === 'object') {
        for (var key in name) {
          obj[action].apply(obj, [key, name[key]].concat(rest));
        }

        return false;
      } // Handle space separated event names.


      if (eventSplitter.test(name)) {
        var names = name.split(eventSplitter);

        for (var i = 0, l = names.length; i < l; i++) {
          obj[action].apply(obj, [names[i]].concat(rest));
        }

        return false;
      }

      return true;
    }; // A difficult-to-believe, but optimized internal dispatch function for
    // triggering events. Tries to keep the usual cases speedy (most internal
    // Backbone events have 3 arguments).


    var triggerEvents = function triggerEvents(events, args) {
      var ev,
          i = -1,
          l = events.length,
          a1 = args[0],
          a2 = args[1],
          a3 = args[2];

      switch (args.length) {
        case 0:
          while (++i < l) {
            (ev = events[i]).callback.call(ev.ctx);
          }

          return;

        case 1:
          while (++i < l) {
            (ev = events[i]).callback.call(ev.ctx, a1);
          }

          return;

        case 2:
          while (++i < l) {
            (ev = events[i]).callback.call(ev.ctx, a1, a2);
          }

          return;

        case 3:
          while (++i < l) {
            (ev = events[i]).callback.call(ev.ctx, a1, a2, a3);
          }

          return;

        default:
          while (++i < l) {
            (ev = events[i]).callback.apply(ev.ctx, args);
          }

      }
    };

    var listenMethods = {
      listenTo: 'on',
      listenToOnce: 'once'
    }; // Inversion-of-control versions of `on` and `once`. Tell *this* object to
    // listen to an event in another object ... keeping track of what it's
    // listening to.

    _.each(listenMethods, function (implementation, method) {
      Events[method] = function (obj, name, callback) {
        var listeners = this._listeners || (this._listeners = {});

        var id = obj._listenerId || (obj._listenerId = _.uniqueId('l'));

        listeners[id] = obj;
        if (_typeof(name) === 'object') callback = this;
        obj[implementation](name, callback, this);
        return this;
      };
    }); // Aliases for backwards compatibility.


    Events.bind = Events.on;
    Events.unbind = Events.off; // Mixin utility

    Events.mixin = function (proto) {
      var exports = ['on', 'once', 'off', 'trigger', 'stopListening', 'listenTo', 'listenToOnce', 'bind', 'unbind'];

      _.each(exports, function (name) {
        proto[name] = this[name];
      }, this);

      return proto;
    }; // Export Events as BackboneEvents depending on current context


    {
      if ( module.exports) {
        exports = module.exports = Events;
      }

      exports.BackboneEvents = Events;
    }
  })();
});
var backboneEventsStandalone_1 = backboneEventsStandalone.BackboneEvents;

var backboneEventsStandalone$1 = backboneEventsStandalone;

/**
 * Find out if an object has a certain property
 *
 * @param {object} object
 * @param {string} key
 */

function has(object, key) {
  return Object.prototype.hasOwnProperty.call(object, key);
}
/**
 * Cache class
 */


function Cache() {
  this.initialize.apply(this, arguments);
}

var _ = Cache.prototype;
backboneEventsStandalone$1.mixin(_);
/**
 * Constructor
 *
 * @param {object} external Forward set, get, clear and del commands to an external handler (optional)
 */

_.initialize = function (external) {
  this.store = {};
  this.external = external;
};
/**
 * Insert or overwrite data
 *
 * @param {string} key
 * @param {mixed} value
 * @param {number} ttl   Time to live in milliseconds (optional)
 */


_.set = function (key, value, ttl) {
  if (typeof key === 'undefined') throw new Error('Required argument key is undefined'); // Clear timeout on existing record

  var oldRecord = has(this.store, key) ? this.store[key] : undefined;

  if (oldRecord && oldRecord.timeout) {
    infiniteTimeout.clear(oldRecord.timeout);
  } // Set value + timeout on new record


  var record = {
    value: value
  };

  if (typeof ttl === 'number') {
    record.timeout = infiniteTimeout.set(this.delInternal.bind(this, key), ttl);
  }

  this.store[key] = record; // Call external handler

  if (this.external && typeof this.external.set === 'function') {
    this.external.set(key, value, ttl);
  } // Emit update/set events


  var action = oldRecord ? 'update' : 'set';
  this.trigger(action, key, value, ttl);
  this.trigger(action + ':' + key, value, ttl);
};
/**
 * Get cached data
 *
 * @param {string} key
 * @param {function} callback  Return value in callback if records exists locally or on external resource (optional)
 * @return {mixed} value Only returned if callback is undefined
 */


_.get = function (key, callback) {
  if (typeof key === 'undefined') throw new Error('Required argument key is undefined');

  if (has(this.store, key)) {
    if (typeof callback === 'function') {
      process.nextTick(callback.bind(null, this.store[key].value));
    } else {
      return this.store[key].value;
    }
  } else if (typeof callback === 'function' && this.external && typeof this.external.get === 'function') {
    this.external.get(key, callback);
  }
};
/**
 * Delete cached data
 *
 * @param {string} key
 * @return {boolean} Returns true if record existed
 */


_.del = function (key) {
  if (typeof key === 'undefined') throw new Error('Required argument key is undefined');

  if (this.external && typeof this.external.del === 'function') {
    this.external.del(key);
  }

  return this.delInternal(key);
};

_.delInternal = function (key) {
  if (has(this.store, key)) {
    // Clear timeout
    if (this.store[key].timeout) {
      infiniteTimeout.clear(this.store[key].timeout);
    } // Delete record


    delete this.store[key]; // Emit del events

    this.trigger('del', key);
    this.trigger('del:' + key);
    return true;
  } else {
    return false;
  }
};
/**
 * Clear cached data
 *
 * @return {number} Returns number of cleared records
 */


_.clear = function () {
  var size = this.size();
  this.store = {};

  if (this.external && typeof this.external.clear === 'function') {
    this.external.clear();
  }

  this.trigger('clear', size);
  return size;
};
/**
 * Retrieve number of records
 *
 * @return {number}
 */


_.size = function () {
  var size = 0;

  for (var key in this.store) {
    if (has(this.store, key)) size++;
  }

  return size;
};
/**
 * Retrieve internal store
 *
 * @return {object}
 */


_.debug = function () {
  return this.store;
};
/**
 * Retrieve list of keys
 *
 * @return {string[]}
 */


_.keys = function () {
  return Object.keys(this.store);
};
/**
 * Export a combined instance and constructor
 */


var instance = new Cache();

var constructor = function constructor() {
  return new Cache(arguments[0]);
};

constructor.Cache = Cache;

for (var key in _) {
  if (has(_, key) && typeof _[key] === 'function') {
    constructor[key] = _[key].bind(instance);
  }
}

var cache = constructor;

var jsCache = cache;

var cacheMaxAge = 15 * 60 * 1000;
var log$9 = debug("xpedeo-core:http");
debug.enable(process.env.VUE_APP_DEBUG || "");
var httpPlugin = {
  __$xp: null,
  __axiosInstance: null,
  __requests: [],
  __progressValue: 0,

  get isLoading() {
    return this.__requests.length > 0;
  },

  get progressValue() {
    return this.__progressValue;
  },

  __calculateProgressValue: function __calculateProgressValue() {
    if (this.__requests.length === 0) {
      this.__progressValue = 0;
      return;
    }

    var sum = 0;

    this.__requests.forEach(function (request) {
      sum += request.progress;
    });

    this.__progressValue = sum / this.__requests.length;
  },
  __setProgress: function __setProgress(key, value) {
    if (value === 100) {
      this.__requests = this.__requests.filter(function (request) {
        return request.key !== key;
      });
    } else {
      this.__requests = this.__requests.map(function (request) {
        return {
          key: request.key,
          progress: request.key === key ? value : request.progress,
          cancelToken: request.cancelToken
        };
      });
    }

    this.__calculateProgressValue();
  },
  getPageData: function getPageData(id) {
    return __awaiter(this, void 0, void 0, function () {
      var baseUrl, useStaticPageFiles, url, cancelToken, response, error_1;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!this.__$xp || !this.__axiosInstance) {
              throw new Error("cannot get page without installing http plugin page");
            }

            baseUrl = this.__$xp.settings.baseUrl;
            useStaticPageFiles = this.__$xp.settings.useStaticPageFiles;
            url = '';

            if (useStaticPageFiles) {
              url = baseUrl + "xpedeo/" + this.__$xp.polyglot.apiLangPath + "P" + id + ".json";
            } else {
              url = baseUrl + "xpedeo/" + this.__$xp.polyglot.apiLangPath + "api/v1/pages/" + id + "?expand=children";
            }

            cancelToken = axios.CancelToken.source();

            this.__requests.push({
              key: url,
              progress: 0,
              cancelToken: cancelToken
            });

            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , this.__axiosInstance.get(url, {
              cancelToken: cancelToken.token,
              onDownloadProgress: function onDownloadProgress(e) {
                return _this.__setProgress(url, e.total ? Math.round(e.loaded / e.total * 100) : 100);
              }
            })];

          case 2:
            response = _a.sent();
            return [2
            /*return*/
            , response.data];

          case 3:
            error_1 = _a.sent();

            this.__setProgress(url, 100);

            return [2
            /*return*/
            , {
              Title: 'Error',
              Class: 'XpError',
              Error: error_1,
              // these properties are to avoid js errors while rendering the page
              ID: -1,
              Sections: []
            }];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  },
  getImageUri: function getImageUri(url) {
    return __awaiter(this, void 0, void 0, function () {
      var dataUri, cancelToken, response, image, dataUri_1, error_2;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!this.__axiosInstance) {
              throw new Error("cannot get image uri without installing http plugin page");
            }

            dataUri = jsCache.get(url);

            if (dataUri) {
              return [2
              /*return*/
              , jsCache.get(url)];
            }

            cancelToken = axios.CancelToken.source();

            this.__requests.push({
              key: url,
              progress: 0,
              cancelToken: cancelToken
            });

            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , this.__axiosInstance.get(url, {
              cancelToken: cancelToken.token,
              responseType: 'arraybuffer',
              onDownloadProgress: function onDownloadProgress(e) {
                return _this.__setProgress(url, e.total ? Math.round(e.loaded / e.total * 100) : 100);
              }
            })];

          case 2:
            response = _a.sent();
            image = btoa(new Uint8Array(response.data).reduce(function (data, byte) {
              return data + String.fromCharCode(byte);
            }, ''));
            dataUri_1 = "data:" + response.headers['content-type'].toLowerCase() + ";base64," + image;
            jsCache.set(url, dataUri_1, cacheMaxAge);
            return [2
            /*return*/
            , dataUri_1];

          case 3:
            error_2 = _a.sent();

            this.__setProgress(url, 100);

            throw error_2;

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  },
  cancelRequest: function cancelRequest(key) {
    var request = this.__requests.find(function (request) {
      return request.key === key;
    });

    if (request) {
      request.cancelToken.cancel();
    } else {
      log$9('cannot find request to cancel it');
    }
  },
  cancelRequestsQueue: function cancelRequestsQueue() {
    console.log('cancel requests queue');

    this.__requests.forEach(function (request) {
      request.cancelToken.cancel();
    });
  },
  install: function install(Vue, opts, $xp, cfg) {
    log$9("installing http plugin");

    if ($xp.httpInstalled) {
      return;
    }

    $xp.httpInstalled = true;
    this.__$xp = $xp;
    this.__axiosInstance = axios.create({
      headers: {
        'Cache-Control': 'no-cache'
      }
    });
    Vue.util.defineReactive($xp, "http", this);
  }
};

var localPageData = {
  props: {
    localPageData: {
      type: Object,
      required: false
    }
  },
  computed: {
    pageData: function pageData() {
      return this.localPageData || this.$xp.content.pageData;
    }
  }
};

var page = {
  mixins: [localPageData],
  computed: {
    pageData: function pageData() {
      return this.localPageData || this.$xp.content.pageData;
    }
  },
  created: function created() {
    this.$xp.history.nextPageId = this.$xp.content.pageData.NextPageID;
    /**
     * this condition is important to avoid tabs flickering
     * - on router change pageData will be set to {} till loading the new page or error happen
     * - ignore XpHome tabs, only children tabs are important
     */
    // if (this.pageData !== {} && this.pageData.Class !== 'XpHome') {

    if (this.pageData.Homepage) {
      this.$xp.history.addHomePage(this.pageData.Homepage.ID, "/page/".concat(this.pageData.Homepage.ID), this.pageData.Title);
      this.$xp.navigation.setTabs(this.pageData.Homepage.Tabs);
      this.$xp.navigation.setActiveTabId(this.pageData.ID);
    } else {
      this.$xp.navigation.resetTabs();
    } // }


    if (this.pageData.children && this.pageData.children.length && this.pageData.Class !== 'XpMenu') {
      this.$xp.navigation.setChildPagesMenuItems(this.pageData.children.map(function (item) {
        return {
          id: item.ID,
          title: item.Title,
          class: item.Class
        };
      }));
    } else {
      this.$xp.navigation.resetChildPagesMenuItems();
    }
  },
  methods: {
    setScrollFromHistory: function () {
      var _setScrollFromHistory = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var key,
            scrollableElement,
            lastScrollTop,
            _args = arguments;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                key = _args.length > 0 && _args[0] !== undefined ? _args[0] : undefined;

                // get last scroll value from history array and set it
                if (!key) {
                  key = 'lastScrollTop';
                }

                scrollableElement = document.querySelector('div.js-page-content');
                lastScrollTop = this.$xp.history.historyParams[key];

                if (scrollableElement && !isNaN(lastScrollTop)) {
                  console.log('set scroll from history: ' + lastScrollTop);
                  scrollableElement.scrollTop = lastScrollTop; // set again for delayed render

                  setTimeout(function () {
                    scrollableElement.scrollTop = lastScrollTop;
                  }, 0);
                } else {
                  scrollableElement.scrollTop = 0;
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setScrollFromHistory() {
        return _setScrollFromHistory.apply(this, arguments);
      }

      return setScrollFromHistory;
    }(),
    setChildPagesHiddenFromHistory: function setChildPagesHiddenFromHistory() {
      // get last child pages value from history array and set it
      if (this.$xp.navigation.childPagesMenuItems.length) {
        var lastChildPagesState = this.$xp.history.historyParams['lastChildPagesState'];

        if (lastChildPagesState !== undefined && lastChildPagesState !== this.$xp.navigation.isChildPagesMenuHidden) {
          this.$xp.navigation.toggleChildPagesMenu();
        }
      }
    }
  },
  mounted: function mounted() {
    this.setScrollFromHistory();
    this.setChildPagesHiddenFromHistory();
  },
  watch: {
    '$xp.navigation.currentEntry': {
      handler: function handler(newVal) {
        if (!this.$xp.navigation.isFullScreen && this.$xp.navigation.isAudioSynced) {
          this.$scrollTo('#' + newVal);
        }
      }
    }
  }
};

var XpErrorPage = Vue.extend({
  name: 'XpErrorPage',
  mixins: [page],
  computed: {
    errorMessage: function errorMessage() {
      if (!this.$xp.network.isOnline) {
        return this.$t('global.errorOffline');
      }

      if (this.pageData.Error) {
        if (this.pageData.Error.response) {
          switch (this.pageData.Error.response.status) {
            case 404:
              return this.$t('global.error404');

            case 500:
              return this.$t('global.error500');
          }

          if (this.pageData.Error.response && this.pageData.Error.response.data && this.pageData.Error.response.data.message) {
            return this.pageData.Error.response.data.message;
          }
        }

        return this.pageData.Error.message;
      }

      return this.$t('global.errorUnknown');
    }
  },
  render: function render(h) {
    return h('div', {
      class: 'c-error-page'
    }, [h('span', {
      staticClass: 'xp xp--huge',
      class: {
        'xp-no-wlan': !this.$xp.network.isOnline,
        'xp-connection-error': this.$xp.network.isOnline
      }
    }), h('p', {}, this.errorMessage)]);
  }
});

var dateString = function dateString(isoDateString) {
  var date = new Date(isoDateString);
  return "".concat(date.getDate().toString().padStart(2, '0'), "-").concat((date.getMonth() + 1).toString().padStart(2, '0'), "-").concat(date.getFullYear());
};
var timeString = function timeString(isoDateString) {
  var date = new Date(isoDateString);
  return "".concat(date.getHours().toString().padStart(2, '0'), ":").concat(date.getMinutes().toString().padStart(2, '0'));
};
var formatPlayTime = function formatPlayTime(time) {
  if (time > 0) {
    var minutes = Math.floor(time / 60);
    var seconds = (time % 60).toFixed(0).padStart(2, '0');
    return minutes + ':' + seconds;
  }

  if (time < 0) {
    time *= -1;

    var _minutes = Math.floor(time / 60);

    var _seconds = (time % 60).toFixed(0).padStart(2, '0');

    return '-' + _minutes + ':' + _seconds;
  }

  return '0:00';
};

var log$a = debug('xpedeo-core:install');
debug.enable(process.env.VUE_APP_DEBUG);
var version = '__VERSION__';
var $xp = {
  version: version
};
var coreComponents = {
  'audio-player': function audioPlayer() {
    return import('./AudioPlayer.js');
  },
  'NetworkErrorScreen': function NetworkErrorScreen() {
    return import('./NetworkErrorScreen.js');
  },
  'NumpadInput': function NumpadInput() {
    return import('./NumpadInput.js');
  },
  'Panorama': function Panorama() {
    return import('./Panorama.js');
  },
  'PanzoomMap': function PanzoomMap() {
    return import('./PanzoomMap.js');
  },
  'XpSection': function XpSection() {
    return import('./Section.js');
  },
  'Slider': function Slider() {
    return import('./Slider.js');
  },
  'VideoPlayer': function VideoPlayer() {
    return import('./VideoPlayer.js');
  },
  'ArEntry': function ArEntry() {
    return import('./ArEntry.js');
  },
  'ContactEntry': function ContactEntry() {
    return import('./ContactEntry.js');
  },
  'EntityEntry': function EntityEntry() {
    return import('./EntityEntry.js');
  },
  'HtmlEntry': function HtmlEntry() {
    return import('./HtmlEntry.js');
  },
  'ImageEntry': function ImageEntry() {
    return import('./ImageEntry.js');
  },
  'MenuEntry': function MenuEntry() {
    return import('./MenuEntry.js');
  },
  'PanoramaEntry': function PanoramaEntry() {
    return import('./PanoramaEntry.js');
  },
  'TextEntry': function TextEntry() {
    return import('./TextEntry.js');
  },
  'VideoEntry': function VideoEntry() {
    return import('./VideoEntry.js');
  },
  'EventEntity': function EventEntity() {
    return import('./EventEntity.js');
  },
  'NewsEntity': function NewsEntity() {
    return import('./NewsEntity.js');
  },
  'XpMapPage': function XpMapPage() {
    return import('./XpMapPage.js');
  },
  'XpMenuPage': function XpMenuPage() {
    return import('./XpMenuPage.js');
  },
  'XpMultipleChoicePage': function XpMultipleChoicePage() {
    return import('./XpMultipleChoicePage.js');
  },
  'XpNfcPage': function XpNfcPage() {
    return import('./XpNfcPage.js');
  },
  'XpNumericInputPage': function XpNumericInputPage() {
    return import('./XpNumericInputPage.js');
  },
  'XpPage': function XpPage() {
    return import('./XpPage.js');
  },
  'XpSelectLanguagePage': function XpSelectLanguagePage() {
    return import('./XpSelectLanguagePage.js');
  },
  'XpSplashScreenPage': function XpSplashScreenPage() {
    return import('./XpSplashScreenPage.js');
  },
  'Dock': function Dock() {
    return import('./Dock.js');
  },
  'Splash': function Splash() {
    return import('./Splash.js');
  },
  'PageContainer': function PageContainer() {
    return import('./PageContainer.js');
  },
  'DynamicPage': function DynamicPage() {
    return import('./DynamicPage.js');
  },
  'DynamicPageInPage': function DynamicPageInPage() {
    return import('./DynamicPageInPage.js');
  },
  'DynamicEntry': function DynamicEntry() {
    return import('./DynamicEntry.js');
  },
  'XpHomePage': function XpHomePage() {
    return import('./XpHomePage.js');
  },
  'XpErrorPage': XpErrorPage,
  'App': function App() {
    return import('./App.js');
  }
};
function install (Vue, opts) {
  if (!opts.router) {
    throw new Error('Core plugin needs router to initialize');
  }

  if (this.__installed) {
    return;
  }

  this.__installed = true;
  var cfg = opts.config || {}; // required plugins

  History.install(Vue, opts, $xp, cfg);
  Polyglot.install(Vue, opts, $xp, cfg);
  Device.install(Vue, opts, $xp, cfg);
  Navigation.install(Vue, opts, $xp, cfg);
  Battery.install(Vue, opts, $xp, cfg);
  Wifi.install(Vue, opts, $xp, cfg);
  Media.install(Vue, opts, $xp, cfg);
  Settings.install(Vue, opts, $xp, cfg);
  Screen.install(Vue, opts, $xp, cfg);
  Network.install(Vue, opts, $xp, cfg);
  httpPlugin.install(Vue, opts, $xp, cfg);
  Content.install(Vue, opts, $xp, cfg); // if (cfg.enableEva) {
  //   Eva.install(Vue, opts, $xp, cfg)
  // }

  if (opts.plugins) {
    log$a("installing plugins");

    var _loop = function _loop(plugin) {
      switch (plugin) {
        case 'nfc':
          log$a("install NFC");
          Promise.resolve().then(function () { return nfc$1; }).then(function (Nfc) {
            Nfc.default.install(Vue, opts, $xp, opts.plugins[plugin]);
          });
          break;

        case 'eva':
          import('./eva.js').then(function (Eva) {
            Eva.default.install(Vue, opts, $xp, opts.plugins[plugin]);
          });
          break;

        case 'positioning':
          import('./positioning.js').then(function (Positioning) {
            Positioning.default.install(Vue, opts, $xp, opts.plugins[plugin]);
          });
          break;

        default:
          throw new Error("Unknown xpedeo plugin \"".concat(plugin, "\""));
      }
    };

    for (var plugin in opts.plugins) {
      _loop(plugin);
    }
  }

  Vue.prototype.$xp = $xp;
  Vue.filter('dateString', dateString);
  Vue.filter('timeString', timeString);
  Vue.filter('formatPlayTime', formatPlayTime);
  var components = Object.assign({}, coreComponents, opts.components || {});

  for (var key in components) {
    Vue.component(key, components[key]);
  } // opts.components && Object.keys(opts.components).forEach(key => {
  //   const c = opts.components[key]
  //   if (typeof c === 'function') {
  //     Vue.component(c.options.name, c)
  //   }
  // })

}

var version$1 = '__VERSION__';
var plugin = {
  version: version$1,
  install: install
};

var log$b = debug('xpedeo-core:nfc');
debug.enable(process.env.VUE_APP_DEBUG); // export plugin

var nfc = {
  __isEnabled: undefined,
  __$xp: null,
  __router: null,

  get isEnabled() {
    return this.__isEnabled;
  },

  enable: function enable() {
    var _this = this;

    log$b('nfc.enable()');

    if (this.__$xp.device.platform === 'browser') {
      log$b("nfc.enable(): nfc is not available in browser");
      return;
    }

    if (this.__$xp.device.platform === 'ios') {
      window.nfc.beginSession(function () {}, function () {
        log$b('Error in nfc.beginSession');
      });
    }

    window.nfc.addNdefListener(this.onNfcNdef.bind(this), function () {
      _this.__isEnabled = true;
    }, function () {
      log$b('Error in nfc.addNdefListener');
    });
  },
  disable: function disable() {
    var _this2 = this;

    log$b('nfc.disable()');

    if (this.__$xp.device.platform === 'browser') {
      log$b("nfc.disable(): nfc is not available in browser");
      return;
    }

    window.nfc.removeNdefListener(this.onNfcNdef.bind(this), function () {
      _this2.__isEnabled = false;
    }, function () {
      log$b('Error in nfc.removeNdefListener');
    });

    if (this.__$xp.device.platform === 'ios') {
      window.nfc.invalidateSession(function () {}, function () {
        log$b('Error in nfc.invalidateSession');
      });
    }
  },
  onNfcNdef: function onNfcNdef(nfcEvent) {
    var tag = nfcEvent.tag;
    log$b('onNfcNdef: ' + JSON.stringify(tag), this.__$xp);

    if (tag.ndefMessage && tag.ndefMessage.length) {
      for (var i in tag.ndefMessage) {
        var message = tag.ndefMessage[i];
        var payload = window.nfc.bytesToString(message.payload);
        log$b('onNfcNdef: payload = ' + payload);
        var match = payload.match(/\/#\/nfc\/(.+)$/);

        if (match) {
          var code = match[1];

          var pageId = window.localStorage.getItem('nfcPageId') || this.__$xp.settings.mergedSettings.nfcPageId;

          if (!pageId) {
            pageId = this.__$xp.settings.getValue('content.startPageID');
          }

          var path = "/page/".concat(pageId, "?nfcCode=").concat(code);
          log$b("router.push: path=".concat(path));

          this.__router.push({
            path: path
          });

          break;
        }
      }
    }
  },
  install: function install(Vue, opts, $xp, cfg) {
    log$b("Installing NFC Plugin");
    var router = opts.router;

    if ($xp.nfcInstalled) {
      return;
    }

    if (!opts.router) {
      throw new Error('NFC plugin needs router to initialize');
    }

    this.__$xp = $xp;
    this.__router = router;

    this.__router.addRoutes([{
      path: '/nfc/:nfcCode',
      redirect: function redirect(to) {
        var pageId = window.localStorage.getItem('nfcPageId') || $xp.settings.getValue('content.nfcPageId');

        if (!pageId) {
          pageId = $xp.settings.getValue('content.startPageID');
        }

        return {
          path: "/".concat($xp.polyglot.urlPath, "page/").concat(pageId),
          query: {
            nfcCode: to.params.nfcCode
          }
        };
      }
    }]);

    $xp.nfcInstalled = true;
    Vue.util.defineReactive($xp, 'nfc', this);
  }
};

var nfc$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': nfc
});

var entry = {
  mixins: [localPageData],
  props: {
    entryData: {
      type: Object,
      required: true
    }
  }
};

var EventHub = {
  Bus: new Vue(),
  TYPES: {
    RE_INIT_IMAGE_MAP: 're-initialize-image-map',
    START_PLAY_MEDIA: 'start-play-media',
    ANDROID_ACTIVITY_PAUSE: 'android-activity-pause'
  }
};

var vm = new Vue();
var nonLangPageRedirect = function nonLangPageRedirect(to) {
  var newTo = Object.assign({}, to, {
    path: "/".concat(vm.$xp.polyglot.urlPath).concat(to.path).replace('//', '/')
  });
  return newTo;
};
var beforeEach = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(to, from, next) {
    var pageData;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            vm.$xp.navigation.isEventConsumerEnabled = true;
            setTimeout(function () {
              vm.$xp.navigation.isEventConsumerEnabled = false;
            }, 60); // save scroll before leaving page

            !to.query.back && saveScrollValue(vm, to, from);

            if (!(to.path === '/' && !vm.$xp.device.isLoan && vm.$xp.settings.mergedSettings.content && vm.$xp.settings.mergedSettings.content.startPageID)) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", next('/_/page/' + vm.$xp.settings.mergedSettings.content.startPageID));

          case 7:
            if (!(vm.$xp.device.platform === 'browser' && vm.$xp.settings.mergedSettings.content && vm.$xp.settings.mergedSettings.content.welcomeScreenId && to.path !== '/')) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return", next({
              path: "/".concat(this.$xp.polyglot.urlPath, "page/").concat(vm.$xp.settings.mergedSettings.content.welcomeScreenId),
              query: {
                backToPath: to.path
              }
            }));

          case 9:
            _context.t0 = to.path;
            _context.next = _context.t0 === '/page/0' ? 12 : _context.t0 === '/_/page/0' ? 12 : _context.t0 === '/page/next-page' ? 14 : _context.t0 === '/_/page/next-page' ? 14 : _context.t0 === '/page/back' ? 15 : _context.t0 === '/_/page/back' ? 15 : _context.t0 === '/page/home' ? 17 : _context.t0 === '/_/page/home' ? 17 : 19;
            break;

          case 12:
            vm.$xp.history.resetHistoryState();
            return _context.abrupt("return", next(from.query.backToPath));

          case 14:
            return _context.abrupt("return", next({
              path: "/page/".concat(vm.$xp.history.nextPageId),
              replace: true
            }));

          case 15:
            next(false);
            return _context.abrupt("return", vm.$xp.history.back(true));

          case 17:
            next(false);
            return _context.abrupt("return", vm.$xp.history.goHome(true));

          case 19:
            if (!(to.name === 'Page')) {
              _context.next = 30;
              break;
            }

            // THIS IS IMPORTANT
            // to avoid render the same section in the new page (this can happen loading the new page takes a while)
            vm.$xp.content.setPageData({});
            /**
             * @TODO test again after releasing this pull request
             * https://github.com/vuejs/vue-router/pull/1906
             * this is needed to check the replace property
             * for now it is always false
             */

            vm.$xp.polyglot.urlPath = to.params.lang + '/';
            _context.next = 24;
            return loadPageData(to);

          case 24:
            pageData = _context.sent;

            if (window.device && window.device.platform === 'browser') {
              window.parent.postMessage({
                name: 'pageLoaded',
                data: {
                  pageID: pageData.ID,
                  pageClass: pageData.Class,
                  langCode: vm.$xp.polyglot.locale
                }
              }, '*');
            }

            if (to.replace || to.query.replace) {
              vm.$xp.history.replace(parseInt(to.params.id), to.path);
            } else {
              vm.$xp.history.push(parseInt(to.params.id), to.path);
            }

            vm.$xp.settings.addPageSettings(pageData.ID, Object.assign({}, pageData.Settings));
            vm.$xp.content.setPageData(pageData);
            return _context.abrupt("return", next());

          case 30:
            return _context.abrupt("return", next());

          case 31:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function beforeEach(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var saveScrollValue = function saveScrollValue(appInstance, to, from) {
  if (!to.query.back) {
    var scrollTopValue = null;
    var scrollableElement = document.querySelector('div.js-page-content');

    if (scrollableElement) {
      scrollTopValue = scrollableElement.scrollTop;
      vm.$xp.history.setHistoryParam(from.params.id, 'lastScrollTop', scrollTopValue);
    }
  }
};

var loadPageData = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(to) {
    var pageId, data, entriesList;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            pageId = to.params.id ? parseInt(to.params.id) : vm.$xp.settings.getValue('content.startPageID');
            _context2.next = 3;
            return vm.$xp.http.getPageData(pageId);

          case 3:
            data = _context2.sent;
            vm.$xp.navigation.isFullScreen = data.IsFullScreen;
            vm.$xp.navigation.isAudioSynced = data.Audio && data.Audio.Url && data.Audio.Url.length > 0;
            entriesList = [];
            data.Sections.forEach(function (section) {
              entriesList = entriesList.concat(section.entries.map(function (entry) {
                return 'entry-' + entry.ID;
              }));
            });
            vm.$xp.navigation.initEntriesIdList(entriesList);
            document.title = data.Title;
            return _context2.abrupt("return", data);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function loadPageData(_x4) {
    return _ref2.apply(this, arguments);
  };
}();

export { Battery as B, Content as C, Device as D, EventHub as E, History as H, Media as M, Navigation as N, Polyglot as P, Settings as S, Wifi as W, _asyncToGenerator as _, Screen as a, Network as b, httpPlugin as c, page as d, entry as e, nonLangPageRedirect as f, beforeEach as g, regenerator as h, debounce as i, _typeof as j, position as k, localPageData as l, _toConsumableArray as m, nfc as n, _objectSpread2 as o, plugin as p, _defineProperty as q, getDeviceTimeOffset as r, throttle as t, writeEvaRecord as w };
